export default {
    appTitle: "ИСУПО",
    version: "Версия",
    attachment: "Прикачен файл",
    backToLogin: "Обратно към Вход",
    test: "Тест",
    email: "Електронна поща",
    link: 'Линк',
    password: "Парола",
    vatNumberUnique: "Вече съществува запис с този ДДС номер: Име: {name}",
    companyNameUnique: "Вече съществува фирма с това име",
    passworRequirement:
        "Паролата трябва да бъде минимум латински 6 символа и да съдържа поне една малка буква и цифра. (Разрешени специални знаци: @$!%*?&#-+<>`~()^=/\\)",
    passworConfirm: "Потвърждението на паролата не съвпада.",
    confirmPassword: "Потвърждаване на парола",
    userName: "Потребителско име",
    login: "Вход",
    resetPassword: "Промяна на парола",
    resetForgottenPassword: "Промяна на забравена парола",
    logout: "Изход",
    register: "Регистрация",
    important: "Важно!",
    registerEmailInfo:
        "Въведената електронна поща ще бъде използвана за вход в @:appTitle .",
    registerMoodleEmailUsage: "При наличие на регистрация в Портала за електронно обучение на НИП, моля, използвайте същия адрес на електронна поща и тук.",
    registerPasswordHelp:
        "Паролата трябва да бъде минимум 6 латински символа и да съдържа поне една малка буква и цифра. (Разрешени специални знаци: @$!%*?&#-+<>`~()^=/\\)",
    consent: "С регистрирането си се съгласявате да предоставите правото на НИП да обработва личните данни за целите на обученията.",
    choose: "Избери",
    save: "Запис",
    backToRegister: "Обратно в регистър",
    unauthorizedMessage: "Нямате необходимите права!",
    lectors: "Преподаватели",
    participants: "Участници",
    organizers: "Организатори/Партньори",
    details: "Детайли",
    description: "Описание",
    personalData: "Лични данни",
    passedTrainings: "Преминали обучения",
    foreignLanguagesProficiency: "Владеене на чужд език",
    certificatesTitle: "Сертификати",
    attachedDocuments: "Приложени документи",
    addFile: "Добави файл",
    downloadFile: "Свали файл",
    remainingSymbols: "Оставащи символи:",
    today: "Днес",
    yes: "Да",
    no: "Не",
    from: "От",
    to: "До",
    add: "Добави",
    remove: "Премахни",
    contactPerson: "Лице за контакт",
    visible: "Видим",
    unvisible: "Невидим",
    personalSettingsLoaded: "Заредени",
    createSuccess: "Успешо създаване!",
    updateSuccess: "Успешна променя!",
    deleteSuccess: "Успешо изтриване!",
    backToList: "Обратно в списъка",
    backToRelatedEvent: "Обратно в свързаното събитие",
    backToFormsList: "Обратно в списъка с формуляри",
    vatCheckTitle: "Проверка за валидност на ДДС номер",
    nomenclatureEditor: "Редакция на номенклатури",
    foreignCitiesEdit: "Редакция на градове в чужбина",
    eventThemeEditor: "Теми на събитие",
    select: "Изберете",
    documents: "Документи",
    document: "Документ",
    documentsSettings: {
        documentType: "Тип документ",
        types: {
            businessTripOrder: "Командировъчна заповед",
            order: "Заповед",
            contract: "Договор",
            request: "Заявка",
            miscellaneous: "Разни"
        }
    },
    selectFiles: "Изберете файлове",
    selectNomenclature: "Изберете номенклатура ...",
    selectThematicArea: "Изберете тематична област ...",
    selectParticipationType: "Изберете тип участие ...",
    selectCategory: "Изберете категория ...",
    selectBenchmark: "Изберете тип репер ...",
    selectTariffGroup: "Изберете  ...",
    selectContract: "Изберете договор ...",
    selectProperty: "Изберете свойство ...",
    selectEvent: "Изберете събитие ...",
    clientCertLogin: "Вход с КЕП",
    forgottenPassword: "Забравена парола",
    forgottenPasswordOk:
        "На посочения e-mail е изпратен линк за промяна на забравена парола",
    forgottenPasswordError:
        "Грешка при изпращане на линк за промяна на забравена парола",
    forgottenPasswordIsReset: "Успешно променена парола",
    seeMore: "Виж повече",
    seeLess: "Виж по-малко",
    my: "Мои",
    all: "Всички",
    learningActivity: "Учебна дейност",
    eventsMap: "Карта на събитията",
    eventsMapCtrlZoomHint: "Zoom: Ctrl + скрол",
    otherActivities: "Други дейности",
    insufficientRights: "Нямате необходимите права за достъп до тези ресурси.",
    invalidAction: "Невалидно действие!",
    seeDownloadedFile: "Виж сваления файл",
    missingSource: "Липсва валиден източник.",
    missingData: "Липсват данни.",
    sync: "Последователно",
    async: "Асинхронно",
    text: "Текст",
    request_n: "Искане",
    lastUpdatedBy: "Последно редактиран от ",
    lastUpdatedOn: "Последно редактиран на ",
    createdBy: "Създаден от ",
    createdOn: "Създадено на",
    hours: "часа",
    minutes: "минути",
    hoursAbbr: "ч.",
    minutesAbbr: "мин.",
    filesUpload: "Документи",
    namePromptTitle: "Моля, въведете име.",
    noData: "Няма данни",
    isNotUniqueNumber: "Идентификационният номер не е уникален",
    isNotValidEgn: "Идентификационният номер не е валиден",
    outOfActivityRange: "Извън срока на активност!",
    historicalData: "Исторически данни",
    forgotPasswordEmailHelpMessage:
        "Посочете електронната поща на регистрирания потребител",
    invalidEmail: "Невалидна електронна поща",
    missingProfile:
        "Липсва попълнен потребителски профил! Моля, въведете лични данни в потребителския си профил.",
    activeFormCheck:
        "Проверка активността и допустимостта на попълване на формуляра.",
    activeFormCheckError:
        "Възникна грешка при проверка активността и допустимостта на попълване на формуляра.",
    actions: 'Действия',
    of: 'от',
    items: 'записи',
    emptySearchFilter: 'Празен филтър за търсене',
    records: 'запис | записа',
    lastUpdate: 'Промяна',
    administration: {
        user: {
            title: "Администрация на потребител | Администрация на потребители",
            grid: {
                title: "Потребители"
            },
            confirmations: {
                delete: "Сигурни ли сте, че искате да изтриете потребител ",
                edit: "Сигурни ли сте, че искате да редактирате потребител ",
                relatedPersonDelete:
                    "Сигурни ли сте, че искате да премахнете обвързаната личност ",
                relatedPersonAdd:
                    "Сигурни ли сте, че искате да обвържете избраната личност ",
                mergedPersonRemove:
                    "Сигурни ли сте, че искате да премахнете обединената личност ",
                mergedPersonAdd:
                    "Сигурни ли сте, че искате да обедините Личност "
            },
            lastLogTime: "Време на последното записано действие: ",
            relatedPerson: "Обвързана личност",
            missingRelatedPerson: "Липсва обвързана Личност",
            signatureImage: "Картинка на подпис",
            canSignDocument: "Подписване на документ"
        },
        userRoles: {
            title: "Потребителски групи"
        },
        import: {
            title: "Импортиране",
            fileHelperMessage:
                "Услугата очаква екселски файл с три задължителни колони, а именно: "
        },
        person: {
            title: "Личност | Личности",
            searchFormMerged: "Включване в търсенето на обединени профили",
            isParent: 'Родителска личност',
            noneParentSelected: 'Не е избрана родителска личност.',
            emptySelection: "Липсват избрани личности.",
            confirmations: {
                unmerge: 'Сигурни ли сте, че искате да премахнете обединението на личност "{person}"?'
            }
        },
        profile: {
            merge: "Обединен профил | Обединени профили"
        }
    },
    sideMenu: {
        home: "Начало",
        planning: "Планиране",
        annualCatalogProject: "Проект на ГК",
        events: "Събития",
        users: "Потребители",
        persons: "Личности",
        roles: "Роли",
        notifications: "Системни съобщения",
        claims: "Права",
        rooms: "Зали",
        tasksAndCoordinations: "Задачи и съгласуване|Задачи, съгласуване, подписване",
        tasks: "Задачи",
        coordinations: "Съгласуване",
        certificates: "Сертификати",
        registers: "Регистри",
        administration: "Администриране",
        participants: "Участници",
        telerikGrid: "Telerik grid",
        reports: "Справки",
        list: "Списък",
        test: "Тест",
        dynamicRegisters: "Динамични регистри, администрация",
        fieldTypes: "Типове полета",
        registerTypes: "Типове регистри",
        dynamicRegisterEditor: "Редактор",
        dynamicRegisterEditorTest: "Дин.регистри тест",
        staticRegistersForDropdown: "Статични регистри за dropdown",
        panelsFields: "Панели/Полета",
        placesScheduler: "График на местата за провеждане",
        lectors: "Преподаватели",
        employees: "Служители НИП",
        mentors: "Наставници",
        forms: "Фомуляри",
        tariffs: "Тарифи",
        formsAndSurveys: "Формуляри и анкети",
        proposals: "Предложения",
        annualCatalog: "Годишен каталог",
        thematicArea: "Тематична област",
        formActivation: "Шаблони на формуляри",
        all: "Всички",
        reasonForAdmission: "Основание за допускане / недопускане",
        allAppearances: "Всички участия",
        calendar: "Календар",
        agenda: "Учебен план",
        presenceForm: "Присъствен списък",
        budgetTemplate: "Бюджет - шаблони",
        eventStatus: "Статус на събитието",
        documents: "Документи",
        participantsClaims: "Права на участници в събитие",
        reportData: "Данни за справки",
        forum: "Форум",
        nomenclatureTypes: "Номенклатурни типове",
        participationType: "Тип участие",
        benchmarkType: "Тип репер",
        eventSubscriptions: "Абонирани за събития",
        releaseInfo: "Информация за версиите",
        templates: "Шаблони на формуляри",
        lecturersElectronicRegister:
            "Електронен регистър на преподавателите от органите на съдебната власт",
        budgetModule: "Модул бюджет",
        budgetModuleReport: "Модул бюджет - справка",
        usergroups: "Потребителски групи",
        userGroup: "Потребителска група",
        localization: "Текстове на етикети",
        participationRelationType: "Основание за участие",
        applicationSettings: "Настройки на приложението",
        rankingCriteria: "Критерии за класиране",
        sentEmails: "Изпратени ел. писма",
        archivedEvents: "Архивирани събития",
        fieldCodes: "Кодове на полета",
        auxiliaryRegister: "Спомагателни регистри",
        help: "@:help.title",
        migrationCheck: "Проверка на миграцията",
        signing: "Процедури по подписване",
        signatures: "Подписвания",
        company: "Юридически лица",
        deletedRecords: "Изтрити записи",
        signingProcedureFiling: "Завеждане на процедури по подписване",
        summaryFormsReport: "@:buttons.summaryDataReport.btnText"
    },
    dynamicDropdown: {
        noDataFound: "Не са открити записи за:",
        goToSection: "За да създадете запис отидете в раздел"
    },
    validation: {
        requiredField: "Полето е задължително",
        uniqueField: "Полето е уникално",
        readOnlyField: "Полето не се променя",
        defaultTextValue:
            'Полето "Стойност по подразбиране" не може да е празно',
        invalidIntNumber: "Стойността не е валидно цяло число",
        invalidDecimalNumber: "Стойността не е валидно реално число",
        invalidDecimalPrecision: "Стойността трабва да е в диапазона [0-18]",
        ivalidMinMaxValue:
            "Максималната стойност трябва да е по-голяма от минималната",
        themeProposalUniqueName: 'Съществува тема с това име за избраната година'
    },
    userManagement: {
        title: "Управление на потребители",
        user: "Потребител",
        users: "Потребители",
        roles: "Роли",
        info: {
            li1:
                "Позволено е обвързването на Личност, която не е обвързана с друг потребител.",
            li2:
                "Позволено е обвързването на Личност, която не е обединена (не е дете) с друга Личност.",
            li3:
                "При обвързване на Личност с потребител и съществуваща такава, вече обвързана с този потребител, то старата ще се обедини с новата т.е. ще стане нейно дете.",
            li4:
                "Всички личности, добавени към вече обвързаната с този потребител личност, ако има такива, ще бъдат обединени към новата личност (ще станат деца на новата Личност)."
        }
    },
    externalServices: {
        title: "Външни услуги",
        updateCountries: "Обновяване на ном. с държави",
        updateDistricts: "Обновяване на ном. с областни центрове",
        updateCities: "Обновяване на ном. с населени места",
        updateResorts: "Обновяване на ном. с курортни комплекси",
        migrateEvents: "Миграция на събития",
        updateMoodleCategories: "Обновяване на Moodle категории",
        clearCache: "Изтриване на кеша",
        eventsStaticContentSync:
            "Синхронизиране на статичното съдържание на събитията",
        migrateActivities: 'Миграция на ном. "Дейност"',
        migrateDirectorates: 'Миграция на ном. "Дирекция"',
        migratePositions: 'Миграция на ном. "Длъжност"',
        migrateStatPositions: 'Миграция на ном. "Длъжност статистически цели"/"Професионална категория"',
        migrateEmployment: 'Миграция на ном. "Заетост"',
        migrateProjectName: 'Миграция на ном. "Име на проект"',
        migrateInstitutions: 'Миграция на ном. "Институция"',
        migrateFundingType: 'Миграция на ном. "Финансиране"',
        migrateParticipationType: 'Миграция на ном. "Тип участие"',
        migrateLegalArea: 'Миграция на ном. "Правна област"',
        migrateEventType: 'Миграция на ном. "Вид събитие"',
        migrateEventStatus: 'Миграция на ном. "Статус събитие"',
        migrateThematicArea: 'Миграция на ном. "Тематична област"',
        migrateEventTheme: 'Миграция на ном. "Тема на събитие"',
        migrateReasonForParticipation:
            'Миграция на ном. "Основание на участие"',
        migrateEducation: 'Миграция на ном. "Образование"',
        migrateTitle: 'Миграция на ном. "Титла (Звание)"',
        migrateOrganizor: 'Миграция на ном. "Организатор"',
        migratePlaces: 'Миграция на ном. "Място на провеждане"',
        migrateParticipants: "Миграция на участници",
        migrateLecturers: "Миграция на лектори",
        syncLangJsFilesToTheDb: "Save the js localization files to the DB",
        testMoodleDbConnection: "Тестване на връзката с Moodle БД",
        testMoodleExtApi: "Тест на връзката с Мудъл / Извличане на данни за потребител",
        testMoodleExtApiCategory: "Тест на връзката с Мудъл / Извличане на данни за категории"
    },
    nipData: {
        title: "НИП",
        companyData: "Фирмени данни на НИП"
    },
    notificationConfig: {
        title: "Системно съобщение",
        config: "Конфигурация",
        type: "Тип на събитие",
        subject: "Заглавие на съобщение",
        content: "Съдържание на съобщение",
        keywordsDescription:
            "В свободния текст по-долу можете да използвате следните ключови думи, които ще бъдат заместени с данните на обекта: "
    },
    documentsRelation: {
        id: "ИД №",
        name: "Име на файл",
        documentExtension: "Файлово разширение",
        documentType: "Тип на документа",
        title: "Документи",
        type: "Вид",
        event: "Събитие",
        createdOn: "Създадено на",
        createdBy: "Създадено от"
    },
    person: {
        cloneManager: "Клониране на данни за директор/управител",
        cloneContact: "Клониране на данни за лице за контакт",
        resetManager: "Изчисти",
        resetContact: "Изчисти",
        removeManager: "Премахни директор/управител",
        addManager: "Добави директор/управител",
        removeContact: "Премахни лице за контакт",
        addContact: "Добави лице за контакт",
        title: "Лични данни",
        firstName: "Име",
        middleName: "Презиме",
        lastName: "Фамилия",
        firstNameEn: "Име (En)",
        middleNameEn: "Презиме (En)",
        lastNameEn: "Фамилия (En)",
        phone: "Телефон",
        mobilePhone: "Мобилен телефон",
        idCardNumber: "ЛК №",
        idCardDateOfIssue: "Дата на издаване",
        idCardIssuedBy: "Издадена от",
        egn: "ЕГН",
        position: "Длъжност",
        positionFullName: "Пълно наименование на длъжността",
        positionStatistic: "Професионална категория",
        description: "Описание",
        identification: "Идентификационен №",
        gender: "Пол",
        contactAddress: "Адрес за контакт",
        livingAddress: "Адрес по местоживеене",
        gridTitle: "Личност",
        gridHeaders: {
            id: "Ид №",
            fullname: "Име",
            nameTransliterated: 'Име-транслитерирано',
            identificationType: "Тип ид. №",
            identification: "Идентификационен №",
            username: "Потребителско име",
            parent: "Родителски запис",
            hasChanges: "Промени",
            email: "Ел.поща",
            roles: "Потребителски групи",
            deleted: "Изтрит",
            firstName: "Име",
            middleName: "Презиме",
            lastName: "Фамилия",
            hasParent: "Има родителски запис",
            parentId: "ИД № на родител",
            updatedAtUtc: "Дата на последна редакция",
            updatedBy: "Последно редактиран от"
        },
        participation: "Участие",
        certificates: "Сертификати",
        changePassword: "Смяна на парола",
        edit: "Редакция на личност",
        create: "Създаване на личност",
        salutation: "Обръщение",
        titleDegree: "Звание / Степен",
        educationDegree: "Образование",
        institution: "Институция",
        institutionLocation: "Местоположение на институцията",
        relatedToUser: "Обвързан с потребител ",
        specifyInstitution: "Посочи друга институция",
        country: "Държава",
        settlement: "Населено място",
        confirmations: {
            edit: "Сигурни ли сте, че искате да редактирате ",
            create: "Сигурни ли сте, че искате да създадете ",
            delete: "Сигурни ли сте, че искате да изтриете "
        },
        tasks: "Задачи",
        help: {
            institutionHelp: "Търсене по име на институция"
        },
        moodleAccountDetails: "Детайли за акаунт в Moodle",
        moodleAccountLinkLabel: "Връзка към акаунта в Moodle",
        accountSyncedWithMoodle: "Синхронизирано с Moodle",
        moodleAccountSyncResult: "Детайли за синхр. с Moodle",
        deleteMoodleSync: "Изтриване на синхронизацията с Moodle",
        userExistingInMoodleButNotSynced: "В Moodle съществува потребител с електронна поща: {email}, но липсва синхронизация с потребителя в ИСУПО.",
        notAllFoundRecordsDiplayed: "Не са показани всички резултати. За да видите всички резултати, моля задайте по-конкретен филтър.",
        createMoodleAccountHelp: "За Вас ще бъде създаден нов потребителски профил в сайта \"Портал за електронно обучение на Националния институт на правосъдието\" с нова временна парола. Повече информация ще бъ де изпратена на съответната електронна поща.",
        missingPersonAlert: "Не са въведени лични данни! За синхронизация с Moodle са необходими лични данни."
    },
    eventSubscriptions: {
        gridHeaders: {
            id: "ИД № на абонамент",
            eventId: "ИД № на събитие",
            eventName: "Име на събитие",
            eventStartDate: "Начална дата",
            eventEndDate: "Крайна дата",
            eventSubscriptionStartDate: "Начало записване",
            eventSubscriptionEndDate: "Край записване",
            notificationTypeName: "Тип абонамент",
            userName: "Потребителско име",
            email: "E-mail",
            note: "Бележки",
            createdAt: "Абониран на"
        }
    },
    changePassword: {
        oldPassword: "Стара парола",
        newPassword: "Нова парола",
        newPasswordConfirm: "Нова парола потвърждение",
        title: "Смяна на парола"
    },
    otherFields: {
        other1: "Друго 1",
        other2: "Друго 2",
        otherFields: "Други полета"
    },
    address: {
        cardTitle: "Адрес",
        cloneRegistrationAddress: "Клониране на данни за адрес на регистрация",
        cloneContactAddress: "Клониране на данни за адрес за кореспонденция",
        postCode: "Пощенски код",
        settlement: "Населено място",
        settlementEn: "Населено място(EN)",
        country: "Държава",
        countryEn: "Държава(EN)",
        street: "Улица",
        streetNum: "№",
        coords: "Координати",
        long: "Дължина",
        lat: "Ширина",
        areaOfAppeal: "Апелативен район",
        settlementIdHelper: "Номенклатура на населените места в България",
        settlementHelper: "Населено място свободен текст",
        coordsFromAddress: "Координати от адрес"
    },
    accommodation: {
        accommodationPlaces: "Места за настаняване",
        name: "Име",
        nameEN: "Име на английски",
        category: "Категоризация",
        url: "URL",
        type: "Тип",
        roomPrice: "Цени на стаи",
        title: "Настаняване",
        single: "Единична",
        double: "Двойна",
        triple: "Тройна",
        apartment: "Апартамент",
        food: "Изхранване",
        menu: "Меню"
    },
    externalSupplier: {
        title: "Договори",
        company: "Данни на изпълнителя",
        contactPersons: "Лица за контакт",
        contracts: "Договори",
        id: "ИН",
        status: "Активен",
        addContactPerson: "Контакт",
        addContract: "Договор",
        egnManager: "ЕГН - Директор",
        tariffs: "Тарифи",
        tariff: "Тарифа",
        active: "Активен",
        contractData: "Данни на договор/споразумение",
        tariffName: "Наименование",
        isCompany: "Юридическо лице",
        historyRecordsGridHeader: {
            id: "ИД №",
            companyName: "Име на юридическо лице",
            deactivated: "Деактивиран",
            other1: "Друго 1",
            other2: "Друго 2",
            deleted: "Изтрит",
            personFullName: "Име на физическо лице",
            isCompany: "Юридическо лице",
            externalSupplierSysStartTimeUtc: "Системна валидност от",
            externalSupplierSysEndTimeUtc: "Системна валидност до"
        }
    },
    publicOrder: {
        title: "Обществени поръчки",
        activeTitle: "Активни поръчки",
        archiveTitle: "Архив",
        plannedTitle: "Планирани поръчки",
        currentNumberPublicOrders:
            "Пореден номер на обществената поръчва в регистъра на обществените поръчки на Агенцията за обществени поръчки (АОП)",
        currentNumberNIP:
            "Пореден номер на обществената поръчка (дейността) в регистъра на обществените поръчки на НИП",
        itemName: "Предмет на обществената поръчка",
        typeOfOrderType: "Вид възлагане",
        orderType: "Вид дейност по ЗОП",
        documents: "Документи",
        status: "Статус",
        publishDate: "Дата на публикуване",
        addFile: "Добави документ",
        description: "Описание",
        termDate: "Краен срок за оферти",
        objectType: "Обект на поръчката",
        referenceValue: "Прогнозна стойност на поръчката",
        referenceValueCurrency: "Валута",
        fileNumber: "Номер на преписка",
        documentType: "Тип на документа",
        documentInfo: "Данни за документа",
        documentDate: "Дата на качване на информацията в профила на купувача",
        assignor: "Възложител",
        addContact: "Лице за контакт",
        contactPerson: "Лица за контакт",
        referenceOrder: "Референтна поръчка",
        activity: "Дейност/Направление",
        archive: "Архив",
        manualDocsType: "Указания, документация и образци",
        infoDocsType: "Обявления, информация, покани, съобщения и др.",
        contractDocsType: "Договори и доп. споразумения",
        statementDocsType: "Становища на АОП",
        statusFrom: "От",
        statusTo: "На",
        statusUpdateDate: "Дата",
        statusUpdatedBy: "Променил",
        statusHistory: "Статус история",
        historyRecordsGridHeader: {
            id: "ИД №",
            nipCurrentNumber: "НИП №",
            subject: "Тема",
            publishDateUtc: "Дата на публикуване",
            statusName: "Статус",
            typeName: "Тип",
            assignmentTypeName: "Тип назначение",
            other1: "Друго 1",
            other2: "Друго 2",
            contactPersonId: "Личност за контакт №",
            description: "Описание",
            termDate: "Краен срок",
            objectTypeName: "Тип на обекта",
            referenceValue: "Референтна стойност",
            referenceValueCurrencyName: "Референтна стойност за валута",
            isOpen: "Отворена",
            publicOrdersCurrentNumber: "Обществената поръчка №",
            referenceOrderId: "Референтна поръчка №",
            activityId: "Действие №",
            deleted: "Изтрита",
            sysStartTimeUtc: "Системно начално време",
            sysEndTimeUtc: "Системно крайно време",
            createdAtUtc: "Създадена на",
            createdBy: "Създадена от",
            creatorUsername: "Създадена от",
            updatedAtUtc: "Обновена на",
            updaterUsername: "Обновена от",
            publicOrderSysStartTimeUtc: "Системно начално време на обществената поръчка",
            publicOrderSysEndTimeUtc: "Системно крайно време на обществената поръчка"
        }
    },
    thematicArea: {
        id: "Номер",
        title: "Тематични области",
        information: "Основна информация",
        name: "Име",
        legalArea: "Правна област",
        lector: "Лектор",
        lectors: "Преподавател/и",
        event: "Събитие",
        events: "Събитие/я",
        theme: "Тема",
        thematicArea: "Тематична област",
        thematicAreaProposal: "Предложение за тематична област",
        saveProposal: "Запис на предложение"
    },
    institution: {
        title: "Институции и организации",
        information: "Институция/Организация",
        mainInfo: "Данни за фирма",
        id: "Ид №",
        type: "Тип на организацията",
        level: "Ниво на организацията",
        appellateRegion: "Апелативен район",
        appellateRegionEn: "Апелативен район(EN)",
        name: "Име на организация/институция",
        nameEn: "Име на организация/институция(EN)",
        protocol: "Протокол",
        realMagistratesCount: "Реална численост магистрати",
        realEmployeesCount: "Реална численост съдебни служители",
        formalMagistratesCount: "Щатна численост магистрати",
        formalEmployeesCount: "Щатна численост съдебни служители",
        totalFormalCount: "Щатна численост общо",
        stateGazette: "Държавен вестник",
        vatNumberExistsCheck: "Проверка за използването на ДДС номерът",
        vatNumberExists: "ДДС номерът '{0}' вече се използва в институция '{1}' в запис с номер {2}!"
    },
    activity: {
        title: "Дейности / Направления",
        name: "Име на дейност / направление",
        type: "Тип дейност",
        id: "ИД №",
        subActivity: "Поддейност",
        direction: "Направление",
        subDirection: "Поднаправление",
        information: "Основна информация",
        activity: "Дейност",
        details: "Детайли"
    },
    administrativePosition: {
        id: "ИД №",
        title: "Длъжности в НИП",
        substitutions: "Заместващи длъжности",
        name: "Длъжност",
        department: "Отдел",
        directorate: "Дирекция",
        contactDetails: "Данни за контакт",
        location: "Местоположение",
        information: "Основна информация",
        addSubstitution: "Добави",
        allEmployeesChange: "Промяна за всички служители",
        managerPosition: 'Мениджър'
    },
    project: {
        title: "Проекти",
        information: "Основна информация",
        number: "Вътрешен номер на проект",
        contract: "Договор",
        name: "Име",
        funding: "Финансиране",
        partners: "Партньори",
        partner: "Партньор",
        partnerContract: "Договор на партньор",
        addPartner: "Добави партньор",
        activity: "Дейност / Направление",
        activities: "Дейности / Направления",
        addActivity: "Добави дейност / направление",
        projectActivities: "Дейности по проекта",
        projectActivity: "Дейност по проект"
    },
    searchDropdown: {
        noResults: "Няма намерени резултати",
        minSearchChars: "Въведете минимум {searchMinLength} символа за тъсене ..."
    },
    foreignLanguage: {
        language: "Език",
        fluencyLevelByEEP: "Ниво на владеене по ЕЕР",
        fluencyLevelBySelfAssessment: "Ниво по самооценка",
        addForeignLanguage: "Добави чужд език"
    },
    organizerActivity: {
        cardTitle: "Активност - резултат / история",
        name: "Име",
        date: "Дата",
        description: "Описание",
        eventType: "Събитие",
        partnershipForm: "Форма на партньорство",
        finParticipationType: "Финансово участие "
    },
    company: {
        title: "@:sideMenu.company",
        id: "Ид №",
        cardTitle: "Фирмена информация",
        name: "Име",
        vatNumber: "ДДС номер",
        bulstatUic: "Булстат",
        phone: "Телефон",
        fax: "Факс",
        url: "Инт. страница",
        description: "Описание",
        manager: "Директор/Управител",
        contact: "Лице за контакт",
        registeredAddress: "Адрес на регистрация",
        contactAddress: "Адрес за кореспонденция",
        bankAccount: "Банкова сметка",
        createdAt: "Дата на създаване",
        updatedAt: "Дата на последно обновяване",
        createdBy: "Създадена от",
        updatedBy: "Последно редактиран от",
        email: "Електронна поща",
        edit: "Редакция на юридическо лице"
    },
    contract: {
        cardTitle: "Договор / Споразумение",
        number: "Номер",
        amount: "Сума",
        name: "Наименование",
        subject: "Предмет на договора",
        validFrom: "Валиден от",
        validTo: "Валиден до",
        conclusionDate: "Дата на сключване",
        description: "Описание",
        externalSupplier: "Външен доставчик"
    },
    bankAccount: {
        cardTitle: "Банкова сметка",
        bankName: "Банка",
        bic: "BIC",
        iban: "IBAN",
        description: "Описание"
    },
    account: {
        title: "Профил",
        logs: "Журнал на действията",
        auditlogs: "Системен журнал",
        audit: {
            gridHeaders: {
                id: "ИД №",
                userName: "Потребител",
                actionName: "Метод",
                controllerName: "Контролер",
                activity: "Статус",
                ipAddress: "IP адрес",
                duration: "Продължителност в ms",
                timeAccessed: "Време",
                timeAccessedUtc: "Време UTC",
                formatedTimeUtc: "Време UTC",
                requestMethod: "Тип заявка",
                urlAccessed: "Url",
                sessionId: "Id на сесия",
                auditTypeStr: "Тип одит",
                hash: "Хеш за сигурност",
                data: "Данни",
                additionalData: "Допълнителни данни"
            }
        },
        log: {
            gridHeaders: {
                id: "ИД №",
                auditId: "Системен №",
                userName: "Потребител",
                description: "Действие",
                time: "Време",
                actionName: "@:account.audit.gridHeaders.actionName",
                controllerName: "@:account.audit.gridHeaders.controllerName",
                type: "Тип"
            }
        }
    },
    audit: {
        validation: "Валидация",
        chainValidation: "Валидация на верига"
    },
    kendoGrid: {
        columnsVisibility: "Видимост на колоните",
        userSettings: "Потребителски настройки",
        loadedFromDbUserSettings: "Заредени персонализирани",
        excelExportSettings: "Настройки на експорта в Excel",
        pdfExportSettings: "Настройки на експорта в Pdf",
        options: {
            columnMenu: "Показване на меню в заглавието на колоните",
            reorderable: "Позволяване на пренареждане на колоните",
            resizable: "Позволяване на преоразмеряване на колоните",
            groupable: "Позволяване на групиране на колоните",
            filterable: "Позволяване на филтрирането",
            sortable: "Позволяване на сортирането",
            fileName: "Име на файл",
            allPages: "Експорт на всички страници",
            collapsible: "Collapsible",
            avoidLinks: "Избягване на хипервръзки",
            paperSize: "Големина на страницата",
            margin: "Рамка",
            landscape: "Landscape ориентация на страницата",
            repeatHeaders:
                "Повтаряне на заглавията на колоните на всички страници",
            scale: "Мащаб",
            rowsPerPage: "Брой редове на страница",
            scrollable: "Позволяване на скролирането",
            selectable: "Режим на копиране на елементи",
            navigatable: "Скролиране в ред",
            removeEllipsis: "Премахване на ограичването на текстовете в рамките на колоната",
            showColumnValueFullText: "Показване на целия текст в полетата"
        },
        infoModal: {
          title: 'Инструкции за скролиране в ред'
        },
        grouping: {
            emptyText: "Довлачете заглавието на колона за да групирате по нея"
        },
        loading: "Зареждане на таблица",
        pagerMessages: {
            display: "{0} - {1} от {2} реда",
            empty: "Липсват данни",
            page: "Страница",
            allPages: "Всички",
            of: "от {0}",
            itemsPerPage: "реда на страница",
            first: "Отиди на първата страница",
            previous: "Отиди на предишната страница",
            next: "Отиди на следващата страница",
            last: "Отиди на посредната страница",
            refresh: "Презареди"
        }
    },
    request: {
        response: {
            status: {
                200: "ОК",
                240: "Warning",
                400: "Невалидна заявка",
                403: "Отказан достъп",
                404: "Не е намерен",
                405: "Методът не е разрешен",
                500: "Сървърна грешка",
                999: "Грешка"
            }
        }
    },
    registers: {
        lectors: {
            id: "ИД №",
            teachingData: "Област на компетентност",
            thematicArea: "Тематична област",
            themes: "Теми",
            lectorsTeaching: "Обучение на обучители",
            universityTeaching: "Преподаване в университет",
            nipTeaching: "Преподаване в НИП",
            practitionersTeaching: "Преподаване на практикуващи юристи",
            status: "Статус",
            notes: "Бележки",
            reasonForJoiningLikeLector:
                "Основание за включване в Електронния регистър",
            reasonForJoining: "Основание за включване",
            decision: "Решение на УС",
            decisionDate: "Дата на решение",
            additionalInfo: "Допълнителна информация",
            reasonForReleaseLikeTeacher:
                "Основание за отпадане от Електронния регистър",
            reasonForRelease: "Основание за отпадане",
            cv: "Биографична справка",
            attachedDocuments: "Приложени документи",
            title: "Титла",
            salutation: "Обръщение",
            identityCard: "Лична карта №",
            identityCardCreatedOn: "Издадена на",
            identityCardCreatedTown: "Издадена от",
            livingAddress: "Адрес по лична карта",
            institution: "Институция",
            workPlace: "Месторабота",
            contractData: "Данни на договор/споразумение",
            eventsParticipation: 'Участия в събития като лектор'
        },
        editor: {
            title: "Редактор"
        },
        organizers: {
            title: "Организатори / Партньори",
            gridHeaders: {
                id: "Id",
                name: "Име",
                description: "Описание",
                companyName: "Име на юридическо лице",
                registeredAddress: "Адрес на регистрация",
                phone: "Телефон",
                managerName: "Име на директор/управител",
                contactName: "Име на лице за контакт",
                active: "Активен"
            }
        },
        accommodation: {
            title: "Места за настаняване",
            menuTitle: "Места за настаняване"
        },
        fieldTypes: {
            title: "Типове полета на динамичните регистри",
            gridHeaders: {
                id: "Id",
                type: "Тип",
                name: "Име",
                nameEn: "Име /Английски",
                deactivated: "Деактивиран",
                active: "Активен"
            }
        },
        registerTypes: {
            title: "Типове динамични регистри",
            gridHeaders: {
                id: "Id",
                name: "Име",
                nameEn: "Име /Английски",
                deactivated: "Деактивиран",
                active: "Активен"
            }
        },
        publicOrder: {
            title: "Обществени поръчки",
            menuTitle: "Обществени поръчки",
            archiveTitle: "Архив",
            activeTitle: "Активни",
            plannedTitle: "Планирани"
        },
        staticRegistersForDropdown: {
            title:
                "Статични регистри като източник за dropdown компонент, използван за създаване на динамичен регистър",
            gridHeaders: {
                id: "Id",
                staticRegisterName: "Име на регистър",
                displayMember: "Име на колона използване като display member",
                description: "Описание",
                deactivated: "Деактивиран",
                active: "Активен",
                allowAnonymousAccesss: "Анонимен достъп"
            }
        },
        nomenclatures: {
            title: "Номенклатури",
            add: "Добавяне на номенклатура",
            parentInfo: "Информация за родител",
            foreignCities: 'Градове в чужбина',
            gridHeaders: {
                id: "Id",
                parentId: "Id на родител",
                parentName: "Име на родител",
                parentNameEn: "Име на родител / Английски",
                name: "Име",
                nameEn: "Име / Английски",
                sort: "Число за сортиране",
                description: "Описание",
                deactivated: "Деактивиран",
                active: "Активен",
                deleted: "Изтрит",
                color: "Цвят"
            },
            editor: {
                editActive:
                    "Редакция на поле '@:registers.nomenclatures.editor.active'",
                active: "Активен"
            },
            confirmations: {
                create:
                    "Сигурни ли сте, че искате да създадете номенклатура с име: ",
                edit:
                    "Сигурни ли сте, че искате да редкатирате номенклатура с име: "
            },
            warnings: {
                emptySelection: "Липсват избрани номенклатури."
            }
        },
        dynamic: {
            title: "Динамични регистри",
            gridHeaders: {
                id: "Id",
                name: "Име",
                nameEn: "Име /Английски",
                deactivated: "Деактивиран",
                active: "Активен",
                locked: "Заключен за редакция"
            }
        },
        participants: {
            title: "Участници",
            freeSeats: "Свободни места",
            details: "Детайли на участник",
            edit: "Редакция на участник",
            updatePersonFromParticipant:
                "Редакция на данните на свързаната Личност",
            updatePersonFromParticipantDescription:
                "Определя дали при редакция да се обновят и данните на свързаната Личност",
            gridHeaders: {
                participant: "Участник"
            },
            help: {
                participantsGridInfo:
                    'Показват се записи, чиито "Тип участие" е маркиран да се разбира като "Участник"("Обучаещ се").',
                allAppearanceGridInfo:
                    'Показват се всички записи, независимо от техния "Тип участие".'
            },
            emptySelection: "Липсват избрани участници",
            multipleEditTitle: "Редакция на участници",
        },
        events: {
            title: "Събития",
            eventsOutOfCatalog: 'Събития по теми извън годишен каталог',
            eventsInCatalog: 'Събития по теми от годишен каталог',
            eventForms: "Форма на събитието",
            lockedForEdit: "Събитието е заключено за редакция",
            lecturers: {
                title: "Преподаватели",
                noLecturers: "Няма добавени преподаватели към това събитие."
            },
            help: {
                eventStartDate:
                    'Начална дата и час на събитието. Виж раздел "Общи данни", панел "Основни даннни".',
                eventEndDate:
                    'Крайна дата и час на събитието. Виж раздел "Общи данни", панел "Основни даннни".',
                eventSubscriptionStartDate:
                    'Виж раздел "Общи данни", панел "Бутон за кандидатстване/записване".',
                eventSubscriptionEndDate:
                    'Виж раздел "Общи данни", панел "Бутон за кандидатстване/записване".'
            },
            errors: {
                outOfEventDateRange:
                    'Извън времето на провеждане на самото събитие. Виж раздел "Общи данни", панел "Основни даннни".',
                outOfEventSubscriptionDateRange:
                    'Извън времето за кандидатстване/записване. Виж раздел "Общи данни", панел "Бутон за кандидатстване/записване".'
            },
            warnings: {
                eventHasChanged: 'Има промени! Моля, запишете събитието.'
            },
            gridHeaders: {
                id: "ИД №",
                name: "Име",
                eventCode: "Код на събитието",
                eventStartDate: "Начало",
                eventEndDate: "Край",
                eventSubscriptionStartDate: "Подаване на заявки от",
                eventSubscriptionEndDate: "Подаване на заявки до",
                eventDailyAllowanceFrom: "Дневни от",
                eventDailyAllowanceTo: "Дневни до",
                eventStayFrom: "Настаняване от",
                eventStayTo: "Настаняване до",
                statusName: "Статус",
                eventForm: "Форма на събитието",
                eventType: "Тип на събитие",
                eventVenue: "Място на провеждане / институция",
                eventProjectName: "Име на проект",
                eventOrganizerName: "Организатор/Партньор",
                participantsMaxNum: "Мак.брой обучаеми",
                eventLocation: "Населено място",
                eventActivityDirection: "Дейност (Направление)",
                eventLegalArea: "Правна област",
                eventFundingType: "Финансиране",
                eventNote: "Бележки",
                eventDirectorate: "Дирекция",
                eventAudience: "Целева аудитория",
                thematicArea: "Тематична област",
                theme: "Тема",
                institutionOfEmployment: "Институция",
                eventSort: "Вид на събитието",
                eventMoodleCategory: "Moodle Категория",
                eventDescription: "Описание",
                eventExpectedResults: "Очаквани резултати",
                eventLearningGoals: "Обучителни цели",
                useExtSubscriptionService: "Външна услуга за заявки",
                extSubscriptionService: "Връзка към външната услуга",
                eventMigrationId: "ИД № от миграция",
                eventId: 'ИД № на събитие',
                moduleName: 'Име на модул',
                isMainEventModule: 'Основен модул',
                eventLabel: "Етикети",
            },
            statuses: {
                active: "Активни",
                past: "Минали",
                upcoming: "Предстоящи",
                activeEnrollment: "Активно записване",
                pastEnrollment: "Минало записване",
                upcomingEnrollment: "Престоящо записване",
                deleted: "Изрити",
                deactivated: "Деактивирани"
            },
            tooltip: {
                name: "Име на събитие",
                coords: "Координати",
                link: "Връзка към събитието"
            },
            generalData: {
                title: "Общи данни",
                participantsMaxNum: "Максимален брой обучаеми",
                excludeFromReporting: "Изключване от отчитане",
                syncedWithMoodle: "Синхронизирано с Moodle",
                moodleSyncResult: "Детайли за синхр. с Moodle",
                eventLink: "Връзка към събитието",
                public: "Публично",
                lockedForEdit: "Заключен за редакция",
                syncWithMoodleForPrivateEventBan:
                    "Синхронизирането на непублично събитие с Moodle не е позволено!"
            },
            evaluation: {
                criteria: {
                    title: "Критерии за класиране",
                    useTemplate: "Използвай шаблон",
                    gridHeaders: {
                        id: "Id",
                        code: "Код",
                        name: "Име",
                        nameEn: "Име /Английски",
                        note: "Бележка"
                    },
                    score: "Точки за оценка",
                    value: "Стойност за оценяване",
                    errors: {
                        invalidScore: "Невалидни точки за оценка",
                        invalidValue: "Невалидна стойност",
                        invalidOperator: "Невалиден оператор",
                        invalidProperty: "Невалидно свойство"
                    },
                    add: "Добавяне на критерии за класиране",
                    saveAsTemplate: "Запази като шаблон",
                    additionallyAdded: "Допълнително добавен",
                    date: "Дата",
                    year: "Година",
                    type: "Тип",
                    operator: "Оператор",
                    property: "Свойство"
                },
                participationRequests: {
                    title: "Заявки за участие"
                },
                accommodationRequests: {
                    title: "Заявки за настаняване"
                },
                tempRanking: {
                    title: "Временно класиране",
                    admitted: "Допуснати",
                    rejected: "Отхвърлени",
                    reserve: "Резерви",
                    active: "Активен",
                    version: "Версия",
                    confirmMaxDate: "Крайно време за потвърждаване",
                    eventName: "Име на събитие",
                    eventStartDate: "Начало на събитието",
                    eventEndDate: "Край на събитието",
                    eventDetails: "Детаили на събитие",
                    statistica: "Статистика",
                    new: "Ново",
                    addCandidate: "Добави кандидат",
                    createNewConfirmation:
                        "Сигурни ли сте, че искате да генерирате ново временно класиране? Данните от съществуващото ще бъдат изтрити.",
                    moveToAdmitted:
                        "Сигурни ли сте, че искате да го преместите в Допуснати?",
                    moveToRejected:
                        "Сигурни ли сте, че искате да го преместите в Отхвърлени?",
                    moveToReserve:
                        "Сигурни ли сте, че искате да го преместите в Резерви?",
                    confirmConfirmation:
                        "Сигурни ли сте, че искате да потвърдите участието? Ако е наличен отказа от участие, той ще бъде изтрит!",
                    confirmRejection:
                        "Сигурни ли сте, че искате да откажете участието? Ако е наличено потвърждение на участие, то ще бъде изтрито! Моля, посочете причина.",
                    pendingConfirmation: "Чакащи потвърждение",
                    pendingConfirmationDetails:
                        "Участия от временни класирания, за които е необходимо потвърждение",
                    isConfirmed: "Потвърден",
                    isConfirmRejected: "Отхвърлил потвърждението",
                    isManuallyAdded: "Ръчно добавен",
                    isNotifiedByPhone: "Уведомен по телефон",
                    dateOfNotificationUtc: "Дата на уведомяване",
                    phoneOfNotification: "Телефон на уведомяване",
                    isParticipant: "Участник",
                    confirmed: "Потвърдени участия",
                    confirmedDetails:
                        "Потвърдени участия от временни класирания, за които е необходимо потвърждение",
                    confirmation: {
                        gridHeaders: {
                            time: "Дата на потвърждаване",
                            username: "Потребителско име"
                        },
                        create: "Сигурни ли сте, че искате да добавите ръчно кандидат",
                        update: "Сигурни ли сте, че искате да редактирате кандидат",
                        delete: "Сигурни ли сте, че искате да изтриете кандидат",
                        confirmationDelete: "Сигурни ли сте, че искате да изтриете потвърждението за участие на кандидат",
                        syncWithFormEntityData: "Сигурни ли сте, че искате да обновите '{name}', използвайки данните от формуляра за заявяване на участие?",
                        syncAllWithFormEntityData: "Сигурни ли сте, че искате да обновите кандидатите във временното класиране, използвайки данните от формуляра за заявяване на участие?"
                    },
                    notCreated: "Не е създадено временно класиране.",
                    applyCofirmation:
                        "Сигурни ли сте, че искате да прехвърлите допуснатите временни участници в участници? Ще се прехвърлят само потвърдилите участие!",
                    applySingleCofirmation:
                        "Сигурни ли сте, че искате да прехвърлите избраният допусна участник като реално участващ?",
                    activeButtonInfo:
                        "Активирането, съответно Деактивирането, на временно класиране определя възможността на потребителите да потвърждават участия, както и възможността да се приложи класирането и да се запишат реални участници.",
                    activeButtonInfo1:
                        'При създаването на ново временно класиране се анализират заявки по формуляри от тип "Заявка за участие", чиято активност за попълване е преминала. За информация: карта "Включени формуляри" в секция "Управление на формуляри."',
                    activeButtonInfo2:
                        "При направена настройка на ИСУПО за позволяване създаването на временно класиране без създадени критерии за допустимост и оценка, ще се извърши класиране според времето на създаване на заявката за заявяване на участие.",
                    applyButtonInfo:
                        'Прилагането на временно класиране ще запише допуснатите и потвърдили участие потребители като реални участници, с онование за участие "Допуснат и потвърдил участие".',
                    applyButtonInfo1:
                        'Всеки допуснат и потвърдил участие може да бъде прехвърлен като реален участник, с онование за участие "Допуснат и потвърдил участие". Това е възможно от управлението на всики запис в таблица "Допуснати"',
                    accommodationRequestRequired:
                        "Нeобходима заявка за настаняване",
                    accommodationRequestRequiredHelp:
                        "Ще изиска попълването на информация за настаняване при потвърждаването на участието.",
                    activeButtonInfo3:
                        "За да е активно потвърждаването на участие е необходимо да има допуснати участници, събитието да е публично и предстоящо (без зададена дата за начало или дата в бъдещето). Потвърждаващият участието трябва да притежава право за попълване на форми и анкети (FormSurveyEntity => Create).",
                    editor: {
                        create: "Добавяне на кандидат",
                        update: "Редакция на кандитат",
                        confirmed: "Потвърден",
                        deniedConfirmation: "Отхвърлил потвърждението",
                        deniedReason: "Информация за отхвърляне на потвърждението",
                        moveToRejected: "Преместване в \"Отхвърлени\"",
                        moveToReserve: "Преместване в \"Резерви\""

                    },
                    history: {
                        title: 'История на временно класиране',
                        candidates: 'Кандидати за участие'
                    },
                    notifiedSelectedAdmitted: "Сигурни ли сте, че искате да известите избраните участници?"
                }
            },
            notSaved: "Събитието не е запаметено",
            participants: {
                title: "Участници",
                gridHeaders: {
                    id: "Id",
                    titleDegree: "Звание / Степен",
                    name: "Име",
                    nameTransliterated: "Име (En)",
                    identificationType: "Тип ид. №",
                    identificationNumber: "Ид №",
                    position: "@:person.position",
                    positionStatistic: "@:person.positionStatistic",
                    positionFullName: "@:person.positionFullName",
                    educationDegree: "Образование",
                    institutionNomenclature: "Институция",
                    institutionCity: "Населено място",
                    institutionMigrationName: "Институтиция от миграция",
                    createdAt: "Дата на създаване",
                    updatedAt: "Дата на последно обновяване",
                    createdBy: "Създадена от",
                    updatedBy: "Последно редактиран от",
                    management: "Управление",
                    relationType: "Основание за участие",
                    participationType: "Тип участие",
                    status: "Статус на участие",
                    reasonForAdmission: "Основание за допускане / недопускане",
                    note: "Бележка",
                    eventName: "Събитие",
                    eventStartDate: "Събитие начало",
                    eventEndDate: "Събитие край",
                    syncWithMoodle: "Синхр.",
                    isFromTempRanking: "Вр.класиране",
                    email: "Email",
                    rank: "Ред",
                    score: "Точки",
                    hasCertificate: "Издаден сертификат",
                    eventId: 'Номер на събитие',
                    moduleName: '@:registers.events.gridHeaders.moduleName',
                    isMainEventModule: '@:registers.events.gridHeaders.isMainEventModule',
                    certificateDate: 'Издаден на',
                    moodleId: 'Moodle Id',
                    moodleResults: 'Издадени сертификати от Moodle',
                    notified: 'Известен',
                    notificationDate: 'Дата на известяване',
                    rejectionNote: 'Информация за отхвърляне на потвърждението',
                    completedForms: 'Попълнени формуляри'
                },
                confirmations: {
                    delete: "Сигурни ли сте, че искате да премахнете участник",
                    import:
                        "Сигурни ли сте, че искате да импортирате участници от файл?",
                    certificateIssed:
                        "Вече е издаден сертификат. Сигурни ли сте, че искате да издадете нов? Старият ще се изтрие.",
                    notifiedSelected: "Събитието е минало или започнало! Сигурни ли сте, че искате да известите избраните участници?",
                },
                help: {
                    participationType: "Определя ролята на участие.",
                    relationType: "Определя основанието за участие.",
                    participationStatus:
                        'Връзка към номенклатура "Статус на участие".',
                    reasonForAdmission: ""
                },
                editor: {
                    editParticipationType: "Редакция на поле '@:registers.events.participants.gridHeaders.participationType'",
                    editRelationType: "Редакция на поле '@:registers.events.participants.gridHeaders.relationType'",
                    editReasonForAdmission: "Редакция на поле '@:registers.events.participants.gridHeaders.reasonForAdmission'",
                    editStatus: "Редакция на поле '@:registers.events.participants.gridHeaders.status'",
                    editNote: "Редакция на поле '@:registers.events.participants.gridHeaders.note'",
                    editPosition: "Редакция на поле '@:registers.events.participants.gridHeaders.position'",
                    editPositionStatistic: "Редакция на поле '@:registers.events.participants.gridHeaders.positionStatistic'",
                    editEducationDegree: "Редакция на поле '@:registers.events.participants.gridHeaders.educationDegree'",
                    editInstitutionRegister: "Редакция на поле '@:registers.events.participants.gridHeaders.institutionNomenclature'"
                }
            },
            budget: {
                title: "Бюджет"
            },
            costs: {
                title: "Разходи"
            },
            budgetReport: {
                title: "Отчет"
            },
            subscriptions: {
                title: "Абонирани потребители"
            },
            confirmations: {
                delete: "Сигурни ли сте, че искате да изтриете събитие",
                unDelete: "Сигурни ли сте, че искате да възстановите събитие",
                archive: "Сигурни ли сте, че искате да архивирате събитие",
                unarchive: "Сигурни ли сте, че искате да премахнете отметката 'архивирано' на събитие"
            },
            organizationalDocs: "Организационни документи",
            eventClaims: "Права"
        },
        lecturers: {
            title: "Преподаватели",
            gridHeaders: {},
            confirmations: {
                delete: "Сигурни ли сте, че искате да премахнете преподавател"
            },
            multipleEditTitle: "Редакция на преподаватели",
            emptySelection: "Липсват избрани преподаватели"
        },
        employees: {
            title: "Служители НИП",
            onlyWithValidUsers: "Само с валидни потребители",
            gridHeaders: {
                manager: "Ръководител",
                directorate: "Дирекция",
                workPhone: "Служебен телефон",
                workPlace: "Месторабота",
                workPlaceAddress: "Адрес на месторабота",
                workData: "Служебни данни",
                positionNij: 'Длъжност в НИП',
                userName: "@:userName",
                activeUser: 'Валиден потребител',
                isLeft: 'Напуснал',
                leavingDate: 'Дата на напускане',
                deleted: 'Изтрит'
            },
            activityЕvaluation: "Оценка на дейността",
            year: "Година",
            evaluation: "Оценка",
            organogram: "Органиграма",
            organogramTitle: "Органограма на служителите на НИП"
        },
        mentors: {
            title: "Наставници",
            gridHeaders: {
                id: "ИД №",
                directorate: "Дирекция",
                salutation: "Обръщение",
                workPlace: "Месторабота",
                institution: "Институция",
                startDate: "Начало",
                endDate: "Край",
                additionalInfo: "Допълнителна информация",
                decision: "Решение",
                reasonForJoiningLikeMentor:
                    "Основание за включване като наставник",
                addParticipant: "Добави участник"
            }
        },
        forms: {
            title: "Формуляри",
            management: "Управление на формуляри",
            includedForms: "Включени формуляри",
            templates: "Шаблони",
            templatesCopies: "Копия на шаблони за даденото събитие",
            active: "Активни",
            activeForms: "Активни формуляри",
            my: "Мои формуляри/анкети",
            completed: "Попълнени формуляри/анкети",
            subscriptionMinDateDescription: "",
            subscriptionMaxDateDescription: "",
            choose: "Избери формуляр",
            eventsWithParticipationOnly:
                "Формуляри към събития, в които участвам",
            completionRightsWarning: "Формулярът/Анкетата е ограничен за попълване и редакция.",
            gridHeaders: {
                id: "Ид №",
                registerEntityId: "Ид № на събитие",
                formId: 'Ид № на формуляр',
                eventName: "Събитие",
                eventStartDate: "Начало на събитието",
                eventEndDate: "Край на събитието",
                participationStatus: "Статус на участие",
                name: "Име",
                nameEn: "Име (английски)",
                formType: "Тип",
                formTypeEn: "Тип (английски)",
                validFromUtc: "Валиден от UTC",
                validToUtc: "Валиден до UTC",
                validFrom: "Валиден от ",
                validTo: "Валиден до",
                note: "Бележка",
                isTemplate: "Използва се като шаблон",
                isCompleted: "Попълнен",
                deactivated: "Деактивиран шаблон",
                formToEventDeactivated: "Нарочно активиран за попълване",
                deleted: "Изрити",
                status: "Статус",
                allRecords: "Всички записи",
                validRecords: "Валидни записи",
                deletedRecords: "Изтрити записи",
                deactivatedRecords: "Деактивирани записи",
                creatorUsername: "Създено от",
                createdAtUtc: "Създено на",
                updaterUsername: "Обновено от",
                updatedAtUtc: "Обновено на",
                management: "Управление",
                canEdit: "Може да се редактира",
                position: "Длъжност",
                formName: "Име на Формуляр / Анкета",
                formNameEn: "Име на Формуляр / Анкета (английски)",
                creator: "Създател",
                participationType: "Тип участие",
                isPopulatingRequired: 'Задължително за попълване',
                isAnonymous: "Анонимен Формуляр / Анкета",
                isAuthorHidden: "Заличен автор",
                isFingerprintingDisabled: "Деактивирано пръстово отпечатване"
            },
            editor: {
                name: "Име",
                nameEn: "Име на английски",
                useAsTemplate: "Използва се като шаблон",
                formType: "Тип",
                relatedEvent: "Свързано събитие",
                validFrom: "Валиден от",
                validTo: "Валиден до",
                deactivate: "Деактивиране",
                note: "Бележка",
                header: "Горен колонтитул",
                footer: "Долен колонтитул ",
                helps: {
                    relatedEvent:
                        'Формулярът ще се присъедини към избраното събитие (секция "Управление на формуляри"), от което се определят неговата активност.',
                    participationType: "Определя ролята на участие.",
                    participationType1: "При добавяне на заявка за участие полето следва да е празно.",
                }
            },
            formToEvent: {
                title: "Управление на Формуляри / анкети",
                gridHeaders: {
                    name: "Име",
                    nameEn: "Име (английски)",
                    formType: "Тип",
                    formTypeEn: "Тип (английски)",
                    validFromUtc: "Валиден от",
                    validToUtc: "Валиден до",
                    note: "Бележка",
                    active: "Активен",
                    comletionLink: "Връзка за попълване на формуляр",
                    participationTypes: "Свързано участие"
                },
                create: "Включване на формуляр към събитие",
                edit: "Редактиране на включен формуляр към събитие",
                help: {
                    isTemplateToNameHelp:
                        "Формулярът е маркиран като шаблон и не може да се редактира името му.",
                    formName:
                        "Стойността на '@:registers.forms.gridHeaders.formName' трябва да е уникална."
                },
                warnings: {
                    useUniqueFormName:
                        "Моля, използвайте уникално '@:registers.forms.gridHeaders.formName'."
                }
            },
            confirmations: {
                save:
                    "Сигурни ли сте, че искате да запишете свързаните формуляри?",
                addToForm:
                    "Сигурни ли сте, че искате да добавите избрания формуляр към даденото събитие?",
                deleteLinkedForm:
                    "Сигурни ли сте, че искате да изтриете връзката събитие - формуляр?",
                edit:
                    "Сигурни ли сте, че искате да редактирате избрания формуляр?",
                deleteFormWithRelatedRecords: "Сигурни ли сте, че искате да редактирате избрания формуляр заедно с попълнети записи?",
                deleteLinkedFormWithForm:
                    "Сигурни ли сте, че искате да изтриете връзката събитие - формуляр, включително самия формуляр?"
            },
            help: {
                add:
                    "За добавяне са налични формуляри, които са маркирани като шаблони."
            }
        },
        theme: {
            title: "Тема на събитие",
            gridHeaders: {
                id: "Id",
                thematicArea: "Тематична област",
                legalArea: "Правна област",
                name: "Име",
                nameEn: "Име (En)",
                deactivated: "Деактивиран",
                active: "Активен",
                sort: "Число за сортиране"
            }
        },
        electronicLecturers: {
            title:
                "Електронен регистър на преподавателите от органите на съдебната власт",
            gridHeaders: {
                id: "№",
                fullName: "Три имена",
                titleDegree: "Звание / Титла",
                firstName: "Име",
                middleName: "Презиме",
                lastName: "Фамилия",
                positionStatistic: "Професионална категория",
                position: "Длъжност",
                institutionCompanyName: "Институция",
                institutionCompanyCountry: "Държава",
                institutionCompanyCity: "Населено място",
                thematicAreas: "Тематична област",
                themes: "Теми",
                lectorsTeaching: "Обучение на обучители",
                universityTeaching: "Преподаване в университет",
                nipTeaching: "Преподаване в НИП",
                practitionersTeaching: "Преподаване на практикуващи юристи",
                reasonForJoining: "Основание за включване",
                decisionForJoining: "Решение на УС",
                decisionForJoiningDate: "Дата на решение",
                reasonForRelease: "Основание за отпадане",
                decisionForRelease: "Решение на УС",
                decisionForReleaseDate: "Дата на решение"
            }
        }
    },
    buttons: {
		saveAdnAddNew: 'Запис и добавяне на нов',
        ok: "Добре",
        cancel: "Отказ",
        close: "Затвори",
        open: "Отвори",
        unlockForEdit: 'Отключи за редакция',
        edit: {
            btnText: "Редакция",
            tooltipText: "Редакция",
            action: "Редактиране"
        },
        editInNewTab: {
            btnText: "Редакция в нов таб",
            tooltipText: "Редакция в нов таб"
        },
        editSelected: {
            btnText: "Редакция на избрани",
            tooltipText: "Редакция на избрани"
        },
        deactivate: {
            btnText: "Деактивиране",
            tooltipText: "Деактивиране",
            action: "Деактивиране",
            already: "Вече деактивиран!",
            status: "Деактивиран",
            confirmationText: "Сигурни ли сте, че искате да деактивирате \"{name}\" ?",
        },
        activate: {
            btnText: "Активиране",
            tooltipText: "Активиране",
            action: "Активиране",
            already: "Вече активиран!",
            status: "Активиран",
            confirmationText: "Сигурни ли сте, че искате да активирате \"{name}\" ?",
        },
        create: {
            btnText: "Нов",
            btnText_a: "Нова",
            tooltipText: "Нов",
            tooltipEvent: "Създай събитие",
            action: "Създаване"
        },
        exportTemplate: {
            btnText: "Експорт на шаблон",
            tooltipText: "Експорт Excel темплейт"
        },
        importFromExcel: {
            btnText: "Импорт от Excel",
            tooltipText: "Импорт от Excel"
        },
        delete: {
            btnText: "Изтриване",
            tooltipText: "Изтриване",
            action: "Изтриване",
            already: "Вече изтрит!",
            confirmationText: "Сигурни ли сте, че искате да изтриете?",
            confirmationText1: "Сигурни ли сте, че искате да изтриете \"{name}\" ?"
        },
        undelete: {
            btnText: "Маркиран като неизтрит",
            tooltipText: "Маркиран като неизтрит",
            confirmationText: "Сигурни ли сте, че искате да маркирате като неизтрит?",
            confirmationText1: "Сигурни ли сте, че искате да маркирате като неизтрит \"{name}\" ?",
        },
        details: {
            btnText: "Детайли",
            tooltipText: "Детайли",
            action: "Детайли"
        },
        detailsAll: {
            btnText: "Детайли на всички",
            tooltipText: "Детайли на всички",
            action: "Детайли на всички"
        },
        detailsShowInDescription: {
            btnText: "Детайли на маркираните за показване",
            tooltipText: "Детайли на маркираните за показване",
            action: "Детайли на маркираните за показване"
        },
        detailsActive: {
            btnText: "Детайли на активните",
            tooltipText: "Детайли на активните",
            action: "Детайли на активните"
        },
        detailsInNewTab: {
            btnText: "Детайли в нов таб",
            tooltipText: "Детайли в нов таб",
            action: "Детайли в нов таб"
        },
        accountDetailsInNewTab: {
            btnText: "Детайли на потребител в нов таб",
            tooltipText: "Детайли на потребител в нов таб",
            action: "Детайли на потребител в нов таб"
        },
        pinToDashboard: {
            btnText: "Закачи за начален екран",
            tooltipText: "Закачи за начален екран"
        },
        unpinFromDashboard: {
            btnText: "Откачи от начален екран",
            tooltipText: "Откачи от начален екран"
        },
        minimize: {
            btnText: "Намали",
            tooltipText: "Намали"
        },
        maximize: {
            btnText: "Увеличи",
            tooltipText: "Увеличи"
        },
        hide: {
            btnText: "Скрий",
            tooltipText: "Скрий"
        },
        userSettings: {
            btnText: "Потребителски настройки",
            tooltipText: "Потребителски настройки"
        },
        settings: {
            btnText: "Настройки",
            tooltipText: "Настройки"
        },
        pdfExport: {
            btnText: "Pdf",
            tooltipText: "Експорт в Pdf"
        },
        excelExport: {
            btnText: "Excel",
            tooltipText: "Експорт в Excel"
        },
        saveGridOptions: {
            btnText: "Запис на настройките",
            tooltipText: "Запис на настройките"
        },
        loadGridOptions: {
            btnText: "Зареждане на настройките",
            tooltipText: "Зареждане на настройките"
        },
        delteGridOptions: {
            btnText: "Изтриване на настройките",
            tooltipText: "Изтриване на настройките"
        },
        submit: {
            btnText: "Изпрати",
            tooltipText: "Изпрати"
        },
        clearFilters: {
            btnText: "Изчистване на филтрите",
            tooltipText: "Изчистване на филтрите"
        },
        filter: {
            btnText: "Филтрирай",
            tooltipText: "Филтрирай"
        },
        search: {
            btnText: "Търсене",
            tooltipText: "Търсене"
        },
        save: {
            btnText: "Запис",
            tooltipText: "Запис",
            confirmationText: "Сигурни ли сте,че искате да запишете?"
        },
        complete: {
            btnText: "Попълване",
            tooltipText: "Попълване"
        },
        load: {
            btnText: "Зареждане",
            tooltipText: "Зареждане"
        },
        doLoad: {
            btnText: "Зареди",
            tooltipText: "Зареди"
        },
        add: {
            btnText: "Добавяне",
            tooltipText: "Добавяне",
            action: "Добавяне"
        },
        archive: {
            btnText: "Архивиране",
            tooltipText: "Архивиране"
        },
        unarchive: {
            btnText: "Премахване на отметката 'Архивиран'",
            tooltipText: "Премахване на отметката 'Архивиран'"
        },
        history: {
            btnText: "История",
            tooltipText: "История"
        },
        clear: {
            btnText: "Изчистване",
            tooltipText: "Изчистване"
        },
        syncWithMoodle: {
            btnText: "Синхронизация с Moodle",
            tooltipText: "Синхронизация с Moodle"
        },
        createUserAccountInMoodle: {
            btnText: "Създай потребителски профил в moodle",
            tooltipText: "Създай потребителски профил в moodle"
        },
        reject: {
            btnText: "Отхвърляне",
            tooltipText: "Отхвърляне"
        },
        reserve: {
            btnText: "Резерва",
            tooltipText: "Резерва"
        },
        admit: {
            btnText: "Допусни",
            tooltipText: "Допусни"
        },
        confirm: {
            btnText: "Потвърждаване",
            tooltipText: "Потвърждаване"
        },
        confirmationDelete: {
            btnText: "Изтриване на потвърждаването",
            tooltipText: "Изтриване на потвърждаването"
        },
        reload: {
            btnText: "Презареждане",
            tooltipText: "Презареждане"
        },
        apply: {
            btnText: "Прилагане",
            tooltipText: "Прилагане",
            action: "Прилагане"
        },
        loadUserSettings: {
            btnText: "Зареждане на потр. настройки",
            tooltipText: "Зареждане на потр. настройки"
        },
        copy: {
            btnText: "Копиране",
            tooltipText: "Копиране"
        },
        saveAsTemplate: {
            btnText: "Запазване като шаблон",
            tooltipText: "Запазване като шаблон"
        },
        taskDetails: {
            btnText: "Задача",
            tooltipText: "Задача",
            action: "Задача"
        },
        roleManagement: {
            btnText: "Управление на роли",
            tooltipText: "Управление на роли",
            action: "Управление на роли"
        },
        claimEdit: {
            btnText: "Редакция на права",
            tooltipText: "Редакция на права",
            action: "Редакция на права"
        },
        roleEdit: {
            btnText: "Редакция на права в потребителска група",
            tooltipText: "Редакция на права в потребителска група",
            action: "Редакция на права в потребителска група"
        },
        management: {
            btnText: "Управление",
            tooltipText: "Управление",
            action: "Управление"
        },
        participantsInGroupEdit: {
            btnText: "Редакция на участници в потребителска група",
            tooltipText: "Редакция на участници в потребителска група",
            action: "Редакция на участници в потребителска група"
        },
        createAndLoad: {
            btnText: "Създаване и зареждане",
            tooltipText: "Създаване и зареждане",
            tooltipEvent: "Създаване и зареждане"
        },
        personEdit: {
            btnText: "Редакция на личност",
            tooltipText: "Редакция на личност",
            tooltipEvent: "Редакция на личност"
        },
        personDetails: {
            btnText: "Детайли на личност",
            tooltipText: "Детайли на личност",
            tooltipEvent: "Детайли на личност"
        },
        personSelect: {
            btnText: "Избор на личност",
            tooltipText: "Избор на личност",
            tooltipEvent: "Избор на личност"
        },
        relatedRecords: {
            btnText: "Свързани записи",
            tooltipText: "Свързани записи",
            tooltipEvent: "Свързани записи"
        },
        export: {
            btnText: "Експорт",
            tooltipText: "Експорт",
            tooltipEvent: "Експорт"
        },
        remove: {
            btnText: "Премахни",
            tooltipText: "Премахни",
            tooltipEvent: "Премахни"
        },
        softDelete: {
            btnText: "Меко изтриване",
            tooltipText: "Меко изтриване",
            action: "Меко изтриване",
            confirmationText: "Сигурни ли сте, че искате да изтриете?",
            confirmationText1: "Сигурни ли сте, че искате да изтриете "
        },
        deleteWithPerson: {
            btnText: "Изтриване вкл. личността",
            tooltipText: "Изтриване вкл. личността",
            action: "Изтриване вкл. личността",
            confirmationText: "Сигурни ли сте, че искате да изтриете?",
            confirmationText1: "Сигурни ли сте, че искате да изтриете "
        },
        realDelete: {
            btnText: "Реално изтриване",
            tooltipText: "Реално изтриване",
            action: "Реално изтриване",
            confirmationText: "Сигурни ли сте, че искате да изтриете?",
            confirmationText1: "Сигурни ли сте, че искате да изтриете "
        },
        viewEvent: {
            btnText: "Преглед на събитие",
            tooltipText: "Преглед на събитие",
            tooltipEvent: "Преглед на събитие"
        },
        newTask: {
            btnText: "Нова задача",
            tooltipText: "Нова задача",
            tooltipEvent: "Нова задача"
        },
        newCertificate: {
            btnText: "Нов сертификат",
            tooltipText: "Нов сертификат",
            tooltipEvent: "Нов сертификат"
        },
        editTemplate: {
            btnText: "Редакция на шаблон",
            tooltipText: "Редакция на шаблон",
            tooltipEvent: "Редакция на шаблон"
        },
        detailsTemplate: {
            btnText: "Детайли на шаблон",
            tooltipText: "Детайли на шаблон",
            tooltipEvent: "Детайли на шаблон"
        },
        formCompleteActivate: {
            btnText: "Активиране на попълването",
            tooltipText: "Активиране на попълването",
            tooltipEvent: "Активиране на попълването"
        },
        formCompleteDeactivate: {
            btnText: "Деактивиране на попълването",
            tooltipText: "Деактивиране на попълването",
            tooltipEvent: "Деактивиране на попълването"
        },
        timeRangeEdit: {
            btnText: "Редакция на времената",
            tooltipText: "Редакция на времената",
            tooltipEvent: "Редакция на времената"
        },
        dataReview: {
            btnText: "Преглед на данните",
            tooltipText: "Преглед на данните",
            tooltipEvent: "Преглед на данните"
        },
        summaryDataReview: {
            btnText: "Преглед на обобщените данни",
            tooltipText: "Преглед на обобщените данните",
            tooltipEvent: "Преглед на обобщените данните"
        },
        back: {
            btnText: "Обратно",
            tooltipText: "Обратно",
            tooltipEvent: "Обратно"
        },
        usergroupEdit: {
            btnText: "Описание на потребителска група",
            tooltipText: "Описание на потребителска група",
            action: "Описание на потребителска група"
        },
        usergroupCreate: {
            btnText: "Създаване на потребителска група",
            tooltipText: "Създаване на потребителска група",
            action: "Създаване на потребителска група"
        },
        accommodationRequestDetails: {
            btnText: "Детаили на заявка за настаняване",
            tooltipText: "Детаили на заявка за настаняване"
        },
        reloadCalendar: {
            btnText: "Презареждане на календара",
            tooltipText: "Презареждане на календара"
        },
        saveSettings: {
            btnText: "Запис на настройките",
            tooltipText: "Запис на настройките"
        },
        deleteWithForm: {
            btnText: "Изтриване, включително формуляр/анкета",
            tooltipText: "Изтриване включително формуляр/анкета"
        },
        deleteFormWithRelatedRecords: {
            btnText: "Изтриване, включително попълнени формуляри/анкети",
            tooltipText: "Изтриване, включително попълнени формуляри/анкети"
        },
        formEdit: {
            btnText: "Редакция на формуляр/анкета",
            tooltipText: "Редакция на формуляр/анкета",
            tooltipEvent: "Редакция на формуляр/анкета"
        },
        formDetails: {
            btnText: "Детайли на формуляр/анкета",
            tooltipText: "Детайли на формуляр/анкета",
            tooltipEvent: "Детайли на формуляр/анкета"
        },
        eventEdit: {
            btnText: "Редакция на събитие",
            tooltipText: "Редакция на събитие",
            tooltipEvent: "Редакция на събитие"
        },
        eventDetails: {
            btnText: "Детайли на събитие",
            tooltipText: "Детайли на събитие",
            tooltipEvent: "Детайли на събитие"
        },
        participantDetails: {
            btnText: "Детайли на участник",
            tooltipText: "Детайли на участник",
            tooltipEvent: "Детайли на участник"
        },
        download: {
            btnText: "Свали",
            tooltipText: "Свали документа",
            tooltipEvent: "Свали документа"
        },
        eventLink: {
            btnText: "Към събитието"
        },
        rankingDetails: {
            btnText: "Детайли на класирането",
            tooltipText: "Детайли на класирането"
        },
        criteriaForEventEdit: {
            btnText: "Редакция на критериите към събитието",
            tooltipText: "Редакция на критериите към събитието",
            tooltipEvent: "Редакция на критериите към събитието"
        },
        criteriaForEventEditDelete: {
            btnText: "Изтриване на критериите към събитието",
            tooltipText: "Изтриване на критериите към събитието",
            tooltipEvent: "Изтриване на критериите към събитието"
        },
        admittedNotification: {
            btnText: 'Извести допуснатите',
            tooltipText: 'Извести допуснатите',
        },
        restart: {
            btnText: 'Възобновяване',
            tooltipText: 'Възобновяване'
        },
        mergeSelected: {
            btnText: "Обединяване на избрани",
            tooltipText: "Обединяване на избрани"
        },
        unmerge: {
            btnText: "Премахване на обединението",
            tooltipText: "Премахване на обединението"
        },
        summaryData: {
            btnText: "Обобщени данни",
            tooltipText: "Обобщени данни",
            action: "Обобщени данни"
        },
        summaryDataReport: {
            btnText: "Справка на обобщените данни от анкети",
            tooltipText: "Справка на обобщените данни от анкети",
            tooltipEvent: "Справка на обобщените данни от анкети"
        },
        summaryDataReportNew: {
            btnText: "Справка на обобщените данни на завършили участници",
            tooltipText: "Справка на обобщените данни на завършили участници",
            tooltipEvent: "Справка на обобщените данни на завършили участници"
        },
        summaryDataReportNewAnonymous: {
            btnText: "Справка на обобщените данни от анонимно попълнени анкети",
            tooltipText: "Справка на обобщените данни от анонимно попълнени анкети",
            tooltipEvent: "Справка на обобщените данни от анонимно попълнени анкети"
        },
        summaryDataReportNewAll: {
            btnText: "Справка на обобщените данни от всички попълнени анкети",
            tooltipText: "Справка на обобщените данни от всички попълнени анкети",
            tooltipEvent: "Справка на обобщените данни от всички попълнени анкети"
        },
        newCertificates: {
            btnText: "Нови сертификати",
            tooltipText: "Нови сертификати",
            action: "Нови сертификати"
        },
        syncWithFormEntityData: {
            btnText: "Синхр. с даннните от формуляра",
            tooltipText: "Синхр. с даннните от формуляра",
            action: "Синхр. с даннните от формуляра"
        },
        editWithNoValidation: {
            btnText: "Редакция без валидация",
            tooltipText: "Редакция без валидация",
            action: "Редакция без валидация"
        },
        links: {
            btnText: "Връзки",
            tooltipText: "Съществуващи връзки"
        },
        confirmationRejectionDetails: {
            btnText: "Детайли на отхвърлянето на участие",
            tooltipText: "Детайли на отхвърлянето на участие"
        },
        replace: {
            btnText: "Замести",
            tooltipText: "Замести"
        },
        selectAll: {
            btnText: "Избери всички",
            tooltipText: "Избери всички"
        },
        unselectAll: {
            btnText: "Премахни всички",
            tooltipText: "Премахни всички избрани"
        },
        notifySelected: {
            btnText: "Извести избраните",
            tooltipText: "Извести избраните",
            action: "Известяване на избраните"
        },
        loadProfileData: {
            btnText: "Зареди данните от профила",
            tooltipText: "Зареди данните от профила",
            action: "Зареди данните от профила"
        },
        addLecturers: {
            btnText: "Добавяне/управление на преподаватели",
            tooltipText: "Добавяне/управление на преподаватели",
            action: "Добавяне/управление на преподаватели"
        },
        addParticipant: {
            btnText: "Добавяне/управление на участници",
            tooltipText: "Добавяне/управление на участници",
            action: "Добавяне/управление на участници"
        },
        clearSelection: "Изчисти избора",
    },
    checkboxes: {
        exportWithData: {
            cbText: "Експорт с данни"
        }
    },
    notifications: {
        error: "Грешка",
        success: "Успех",
        successfulSavedData: "Данните са записани успешно",
        successfulDeletedData: "Данните са изтрити успешно",
        errorDataNotSaved: "Данните не са записани",
        invalidUserCredentials: "Невалидни данни за вход",
        serverError: "Грешка на сървъра. Моля опитайте по-късно",
        invalidData: "Невалидни данни",
        errorLoadingData: "Грешка при зареждане на данните",
        errorUploadingFiles: "Грешка при качване на файловете",
        successUploadingFiles: "Файловете са прикачени успешно",
        clientCertLoginError: "Възникна грешка при вход с електронен подпис",
        certLoginRequiredEmail:
            "За да влезете в системата с електронен подпис, трябва да въведете валидна електронна поща",
        duplicateEmail: "Потребител с тази електронна поща вече съществува",
        warning: "Предупреждение",
        dateFromBiggerThanDateTo: "Дата от е по-голяма от дата до!",
        fieldValidationErrors:
            "Съществуват полета с валидационни грешки. Разгледайте формата.",
        noEvent: "Липсва събитие",
        noForm: "Липсва формуляр",
        thereIsNoConnectedEvent: "Липсва свързано събитие",
        thereIsNoConnectedForm: "Липсва свързан формуляр",
        invalidDateTimeRange: "Избраният период за Начало/Край на ангажимент в учебен план е извън периода за Начало/Край на събитието.",
        outOfRange: 'Периодът е извън границите на събитието',
        leavePage: 'Сигурни ли сте, че искате да напуснете страницата?',
        participationsWithAllowedCertificateNotAvailable: 'Няма участия, за които опцията за създаване на нов сертификат да е активна.',
        forbidden: '@:unauthorizedMessage',
        unauthorized: '@:unauthorizedMessage',
        validationError: 'Има валидационни грешки',
        fileSizeLimitExceeded: 'Размерът на файла надвишава максимално допустимия ({maxSize} MB)',
    },
    editor: {
        tools: {
            panel: "Панел",
            textbox: "Текстово поле",
            datepicker: "Дата",
            dropdown: "Dropdown",
            toggle: "Чекбокс",
            personIdentification: "ЕГН",
            fileUpload: "Прикачване на файл",
            address: "Адрес",
            person: "Person",
            personList: "Person list",
            startRating: "Рейтинг поле",
			evaluate: 'Оценка'
        },
        panel: {
            editPanelName: "Редактиране на панел",
            panelName: "Име",
            panelNameEn: "Име на английски",
            panelLabel: "Етикет",
            panelLabelEn: "Етикет на английски",
            initialComponentName: "Първоначалено име",
            initialComponentLabel: "Първоначален етикет",
			participationType: 'Тип участие'
        },
        common: {
            id: "ИН",
            name: "Име",
            nameEN: "Име на английски",
            normalizedName: "Нормализирано име",
            label: "Етикет",
            labelEn: "Етикет на английски",
            textMinLength: "Минимална дължина",
            textMaxLength: "Максимална дължина",
            numberMinLength: "Минимална стойност",
            numberMaxLength: "Максимална стойност",
            textAllowNullOrEmpty: "Позволява празен низ",
            editComponentProperties: "Редактиране на свойства",
            type: "Тип на полето",
            numberType: "Тип число",
            minValue: "Минимална стойност",
            maxValue: "Максимална стойност",
            defaultValue: "Стойност по подразбиране",
            numberFormat: "Формат на числото",
            decimalPrecision: "Цифри след запетаята",
            fieldCode: "Код на полето",
            create: "Създаване",
            read: "Четене",
            update: "Промяна",
            delete: "Изтриване",
            add: "Добави",
            saveAsTemplate: "Запази като шаблон",
            loadTemplate: "Зареди шаблон",
            fieldTemplate: "Шаблон на поле",
            regex: "Регулярен израз",
            regexErrorText: "Текст за грешка от регулярен израз",
            regexErrorTextEn: "Текст на англисйки за грешка от регулярен израз",
            description: "Описание",
            descriptionEn: "Описание на английски",
            showInDescription: "Показване в описание"
        },
        size: {
            length: "Дължина",
            small: "Малка",
            medium: "Средна",
            large: "Голяма"
        },
        input: {
            typeText: "Текст",
            typeNumber: "Число",
            typeTextarea: "Многоредов текст",
            intType: "Цяло число",
            decimalType: "Реално число"
        },
        dropdown: {
            chooseNomenclature: "Избор на номенклатура",
            dropdownType: "Тип dropdown",
            nomenclature: "Номенклатура",
            register: "Регистър",
            dynamicRegister: "Динамичен регистър",
            chooseRegister: "Избери регистър",
            chooseRegisterDisplayName: "Избери колона за показване",
            isMultiDropdown: "Множествен избор",
            isCity: 'Номенклатура от тип "Населени места"'
        },
        errors: {
            loadNomenclaturesError: "Грешка при зареждане на номенклатурите",
            loadStaticRegistersError: "Грешка при зареждане на регистрите",
            loadDisplayMembersError:
                "Грешка при зареждане на колона за показване",
            loadDynamicRegistersError:
                "Грешка при зареждане на динамични регистри"
        }
    },
    places: {
        title: "Места за провеждане",
        halls: "Зали",
        addHall: "Добави зала",
        name: "Име",
        otherFields: "Други полета",
        location: "Място на провеждане"
    },
    hall: {
        hall: "Зала",
        capacity: "Капацитет"
    },
    toggle: {
        checked: "Да",
        unchecked: "Не"
    },
    finance: {
        pageTitle: "Тарифен артикул",
        groups: "Групи",
        tariffItem: {
            title: "Тарифни артикули",
            gridHeaders: {
                id: "Id",
                itemNumber: "Артикулен №",
                groupId: "Id на група",
                group: "Група",
                groupName: "Име на група",
                groupNameEn: "Име на група / Английски",
                name: "Име",
                nameEn: "Име / Английски",
                sort: "Число за сортиране",
                description: "Описание",
                specification: "Спецификация",
                package: "Опаковка",
                code: "Код",
                deactivated: "Деактивиран",
                active: "Активен",
                deleted: "Изтрит",
                qty: "К-во",
                singlePrice: "Ед. цена без ДДС",
                singlePriceWithTax: "Ед. цена с ДДС",
                maxPrice: "Максимална цена без ДДС",
                total: "Total",
                totalWithTax: "Total ДДС",
                measure: "Мерна е-ца"
            }
        },
        tariffEntity: {
            title: "Тарифи",
            gridHeaders: {
                id: "Id",
                contractId: "Id на договор",
                contract: "Договор",
                name: "Име",
                nameEn: "Име / Английски",
                description: "Описание",
                deactivated: "Деактивиран",
                active: "Активен",
                deleted: "Изтрит",
                valid: "Валиден"
            }
        },
        tabcontrol: {
            groups: "Групи",
            tariffItems: "Тарифни артикули",
            tariffEntity: "Тарифи"
        }
    },
    searchBox: {
        placeholder: "Търсене...",
        noItemsFound: "Няма намерени резултати"
    },
    tasks: {
        activity: "Дейност",
        answer: "Отговор",
        event: "Събитие",
        history: "История",
        task: "Задача",
        tasks: "Задачи",
        newTask: "Нова задача",
        newTasks: "Нови задачи",
        notCompleted: "Започната и незпълнена задача|Започнати и неизпълнени задачи",
        overdueTasks: "Просрочена задача|Просрочени задачи",
        title: "Име на задачата",
        text: "Текст",
        type: "Вид",
        priority: "Приоритет",
        category: "Категория",
        deadline: "Краен срок",
        assignees: "Изпълнители",
        assigner: "Възложена от",
        status: "Статус",
        assignedToMe: "Мои задачи",
        createdByMe: "Възложени от мен",
        updateTask: "Обнови статус",
        editTask: "Промяна на задача",
        timeToFinish: "Време за изпълнение",
        deletion: "Изтриване",
        deletionConfirmMessage:
            "Сигурни ли сте, че искате да изтриете тази задача ?",
        assignedOn: "Възложена на",
        attachment: "Прикачен файл",
        attachments: "Прикачени файлове",
        individualTask: "Индивидуална задача",
        individualTaskMessage:
            "Отделна индивидуална задача ще бъде генерирана за всеки от избраните изпълнители",
        groupTaskMessage:
            "Задачата ще е една за всички избрани изпълнители. Всеки от тях ще може да придвижва нейното изпълнение",
        changeTaskType:
            'Добавянето на още изпълнители промяна вида на задачата от индивидуална на групова',
        groupTask: "Групова задача",
        startTask: "Стартирай",
        taskStart: "Стартиране на задача",
        taskStartMessage: "Сигурни ли сте, че искате да стартирате задачата?",
        completeTask: "Изпълнена",
        taskCompletion: "Изпълнена задача",
        done_v: "Потвърди",
        doneConfirm:
            "Сигурни ли сте, че искате да потвърдите приключаването на задачата ?",
        decline: "Откажи",
        taskDecline: "Отказване на задача",
        reason: "Причина",
        return: "Върни",
        returnTask: "Връщане на задача",
        details: "Детайли",
        date: "Дата",
        noAnswerMessage: "Все още няма отговор на тази задача",
        archive: "Архивиране",
        archived: "Архивирана",
        archive_v: "Архивирай",
        archiveMessage:
            "Сигурни ли Сте, че искате да архивирате тази задача? След като се архивира, задачата няма да се вижда в списъци и търсения.",
        unarchive: "Разархивиране",
        unarchive_v: "Разархивирай",
        unarchiveMessage: `Сигурни ли Сте, че искате да разархивирате тази задача? След като се разархивирана, задачата ще бъде видима в списъци и търсения.`,
        addExecutor: 'Добави изпълнител',
        activities: {
            created: "създаде задача",
            edited: "направи промяна",
            deleted: "изтри задачата",
            started: "стартира задачата",
            declined: "не прие задачата",
            completed: "изпълни задачата",
            confirmed: "потвърди изпълнението на задачата",
            returned: "върна задачата за изпълнение",
            archived: "архивира задачата",
            unarchived: "разархивира задачата"
        },
        copy: "Копирай",
        unfinished: "Незавършени задачи",
        switchWithReplacement:
            "Лицето {0} отсъства и е замествано от {1}. Желаете ли избраното лице да бъде заменено от неговия заместник?",
        switchNoReplacement:
            "Лицето {0} отсъства и няма негов заместник. Желаете ли избраното лице да бъде премахнато от списъка?",
        createNewSingingTask: "Създай нова задача за подписване"
    },
    coordinations: {
        accept: "Одобри",
        answer: "Отговор",
        attachments: "Прикачени файлове",
        pageTitle: "Процедури по съгласуване",
        title: "Заглавие",
        newCoordination: "Ново съгласуване",
        newCoordinations: "Нови съгласувания",
        uncompleted: "Незавършено съгласуване|Незавършени съгласувания",
        overdueCoordinations: "Просроченo съгласуване|Просрочени съгласувания",
        edit: "Промяна",
        assignedToMe: "Стартирани процедури",
        createdByMe: "Възложени от мен",
        agreedByMe: "Съгласувани от мен",
        approve_n: "Одобри",
        approved: "Одобрено",
        refuse_n: "Отхвърли",
        requestLink: 'Искане (линк)',
        change_request: "Искане за промяна",
        comments: "Коментари",
        comment: "Коментар",
        commentMessage: "Коментара ще бъде включен във Вашия отговор",
        deadline: "Краен срок",
        type: "Тип на съгласуване",
        coordinators: "Съгласуващи",
        noCoordinatorsMsg: "Няма добавени лица",
        coordDoc: "Документ за съгласуване",
        innerType: "Вътрешно",
        innerTypeMessage:
            "Съгласуването не изисква изходящ номер от деловодната система.",
        ongoing: "в процес ...",
        outgoingType: "Външно",
        outgoingTypeMessage:
            "Съгласуването изисква изходящ номер от деловодната система. Деловодителя трябва да приключи процедурата",
        clerk: "Деловодител",
        start: "Стартирай",
        startTitle: "Стартирай процедурата по съгласуване",
        startMessage: "Сигурни ли Сте, че искате да стартирате съгласуването?",
        status: "Статус",
        reject: "Откажи",
        rejected: "Отказано",
        result: "Резултат",
        deletionConfirmMessage:
            "Сигурни ли Сте, че искате да изтриете съгласуването?",
        startedBy: "Стартирано от",
        createdBy: "Създадена от",
        archive: "Архивиране",
        archived: "Архивирана",
        archive_v: "Архивирай",
        archiveMessage:
            "Сигурни ли Сте, че искате да архивирате тази процедурата по съгласуване? След като се архивира, тя няма да се вижда в списъци и търсения.",
        unarchive: "Разархивиране",
        unarchive_v: "Разархивирай",
        unarchiveMessage: `Сигурни ли Сте, че искате да разархивирате тази процедурата по съгласуване? След като се разархивирана, тя ще бъде видима в списъци и търсения.`,
        activities: {
            created: "създаде съгласувателна процедура",
            edited: "направи промяна",
            deleted: "изтри процедурата",
            started: "стартира процедура по съгласуване",
            approved: "одобри искането за съгласуване",
            rejected: "не прие искането за съгласуване",
            completed: "процедура по съгласуване приключи",
            confirmed: "потвърди съгласувателна процедура",
            archived: "архивира процедурата по съгласуване",
            unarchived: "разархивира процедурата по съгласуване",
            canceled: "прекрати процедурата по съгласуване"
        },
        notYourTurn:
            "Нямате право на това действие в съгласувателната процедура",
        notFound:
            "Процедурата не беше намерена в базата данни или нямате необходимите права",
        cancel: "Прекрати",
        cancelConfirm:
            "Сигурни ли сте, че искате да прекратите тази процедура?",
        cancelation: "Прекратяване",
        cancelationReason: "Причина за прекратяване",
        createFromOrganizationalDocuments: "Създай процедура по съгласуване от избраните документи",
        organizationalDocumentsCoordinationCreateConfirmation: "Сигурни ли сте, че искате да създадете процедурата по съгласуване от избраните организационни документи?",

    },
    planning: {
        planning: "Планиране",
        includeInAnnualCatalog: "Включване в годишен план",
        theme: "Тема",
        alternativeName: "Алтернативно име",
        legalArea: "Правна област",
        lectorsProposal: "Предложение за преподаватели",
        passEventsForTheme: "Проведени събития по темата",
        passEventsLectorsForTheme:
            "Преподаватели участвали в събития по темата",
        pushForCoordination: "Пусни за съгласуване",
        addToAnnualCatalog: "Добави в годишен каталог",
        year: "Година",
        haveNo: "Няма",
        join: "Присъедини",
        addToAnnualCatalogProject: "Добави като проект за ГК",
        themes: "теми",
        _for: "за",
		noThemesFound: 'Няма намерени теми',
		filter: 'Филтър',
		from: 'От',
		to: 'До',
		load: 'Зареди',
		changingDataWarning: 'Промяна ще доведе до презареждане на данните и всички промени ще бъдат загубени',
        validationError: 'Валидационна грешка',
        pleaseFixValidationErrors: 'Моля попълнете задължителните полета',
        directorate: 'Дирекция'
    },
    organizationalProposals: {
        title: 'Организационни предложения',
        proposal: 'Предложение',
        proposedBy: 'Предложил',
        date: 'Дата'
    },
    annualCatalog: {
        annualCatalogProject: "Проект на годишен каталог",
        annualCatalog: "Годишен каталог",
        noData: "Няма данни",
        createdDate: "дата на създаване",
        createdUser: "Създал",
        thereIsCreatedAnnualCatalog: "Вече има създаден годишен каталог за",
        year: "година",
        approved: "Одобрил",
        on: "на",
        coordination: 'Съгласуване'
    },
    presenceForm: {
        title: "Присъствен списък",
        absence: "Отсъствие",
        absenceType: "Вид отсъствие",
        replacement: "Заместник",
        period: "Период",
        noData: "Няма данни",
        dateAbsence: "От",
        dateEndAbsence: "До",
        removeAbsence: "Премахни",
        removeAllAbsence: "Премахни всички",
        reasonForAbsence: "Основание за отсъствието",
        reasonForReplacement: "Основание за заместване",
        creatorUsername: "Създено от",
        restDay: "Почивен ден",
        removeAbsenceConfirm:
            "Сигурни ли сте, че искате да премахнете избраното отсъствие за избраната дата?",
        removeAllAbsenceConfirm:
            "Сигурни ли сте, че искате да премахнете всички отсъствия за избраната дата?"
    },
    scheduler: {
        agenda: "Учебен план",
        management: "Управление на график на зали",
        appointment: "Ангажимент в учебен план",
        appointmentCreate: "Създаване на ангажимент в учебен план",
        appointmentEdit: "Редакция на ангажимент в учебен план",
        title: "Заглавие",
        description: "Описание",
        calendar: "График зали",
        gridHeaders: {
            id: "ИД №",
            date: "Дата",
            eventName: "Събитие",
            startDate: "Начало",
            endDate: "Край",
            timeRange: "Времеви интервал"
        },
        invalidEventSelection: "Невалиден избор на събитие!",
        invalidVenueSelection: "Невалиден избор на място на провеждане!",
        invalidHallSelection: "Невалиден избор на зала!",
        venue: "Място на провеждане",
        hall: "Зала",
        mapVenueToEventCheck:
            "Филтрирай списъка с места за провеждане според избраното събитие",
        hideFromDescription: "Скрий от описание",
        capacity: "Капацитет",
        isAllDay: "Целодневен",
        lecturers: "Преподаватели",
        coordinators: "Координатори",
        lecturersHelpBlock: "Преподаватели добавени в даденото събитие",
        coordinatorsHelpBlock: "Координатори добавени в даденото събитие",
        deleteConfirm:
            "Сигурни ли сте, че искате да изтриете запис със заглавие ",
        isDailyEven: "Ежедневно събитие",
        dailyEventStartTime: "Начален час на ежедневното събитие",
        dailyEventEndTime: "Краен час на ежедневното събитие",
        hallHelpBlock: 'Активно, ако е избрано "Място на провеждане"',
        venueHelpBlock:
            'При избор на горната отметка ще филтрира според избраните места за провеждане на избраното събитие. Виж раздел "Общи данни", панел "Място на провеждане".',
        saveAnyway: "Игнорирай проверката за разлика в интервала на датите на събитието и ангажимента"
    },
    budget: {
        needSavedEvent: "Трябва да се запише събътие първо",
        name: "Име",
        nameEn: "Име на английски",
        tariffItem: "Елемент по тарифа",
        date: "Дата",
        quantity: "К-во",
        singlePrice: "Ед. цена",
        total: "Общо",
        group: "Група",
        new: "Нов",
        edit: "Редакция",
        generateExpenses: "Генерирай разходи",
        expensesGenerated: "Генерирани разходи",
        budgetFor: "Бюджет за",
        expensesPersonOrCompany: "Лице / фирма за рахода",
        areYouSureYouWantToGenerateExpenses:
            "Сигурни ли сте, че искате да генерирате разходи?",
        youCanGenerateExpensesOnce: "Разходи могат да се генерират само веднъж",
        description: "Описание",
        deactivationSuccess: 'Успешно деактивиране',
        activationSuccess: 'Успешно активиране',
        deactivationUnSuccess: 'Неуспешно деактивиране',
        activationUnSuccess: 'Неуспешно активиране'
    },
    budgetReport: {
        participants: "Участници",
        businessTripOrderNumber: "Заповед",
        businessTrip: "Командирован",
        businessTripFrom: "Командирован от",
        businessTripTo: "Командирован до",
        daysCount: "Брой дни",
        daysRate: "Ставка дневни",
        daysRateSum: "Сума дневни",
        nights: "Нощувки",
        nightsFrom: "Нощувки от",
        nightsTo: "Нощувки до",
        nightsCount: "Брой нощувки",
        singlePrice: "Ед. цена",
        apartmentSum: "Сума квартирни",
        roadGoingMoney: "Пътни - отиване",
        date: "Дата",
        roadReturningMoney: "Пътни - връщане",
        roadMoneyAll: "Пътни - общо",
        all: "Всичко",
        payedWithoutApartment: "Изплатени разходи",
        paymentDate: "Дата на плащане",
        excerpt: "Извлечение",
        accountingProgram: "Счетоводна програма",
        difference: "Разлика",
        note: "Забележка",
        financialControl: "Фин. ктрл",
        markAllAsFinancialControl: "Маркирай всички с Финансов контрол"
    },
    budgetTemplate: {
        title: "Бюджет - шаблони"
    },
    budgetModule: {
        plan: "План",
        expense: "Разход",
        financing: "Финансиране",
        balance: "Салдо",
        budgetPosition: "Позиция от бюджета",
        qty: "К-во",
        singlePriceByTariff: "Ед. цена по тарифа",
        total: "Обща стойност",
        totalNijFinancing: "Общо финансиране на НИП",
        totalExternalFinancing: "Общо външно финансиране"
    },
    budgetModuleReport: {
        budgetQty: "План - Количество",
        budgetPrice: "План - Ед. цена",
        budgetTotal: "План - Общо",
        expenseQty: "Разход - Количество",
        expensePrice: "Разход - Ед. цена",
        expenseTotal: "Разход - Общо",
        balance: "Салдо",
        budgetPosition: "Позиция от бюджета",
        total: "Обща стойност",
        groupTotalBudget: "План - Обща стойност(група)",
        totalBudget: "План - Обща стойност",
        groupTotalExpense: "Разход - Обща стойност(група)",
        totalExpense: "Разход - Обща стойност",
        title: 'Модул бюджет - справка'
    },
    calendar: {
        title: "Календар",
        itemType: "Тип на елементите",
        eventFilter: "Филтър на събитията",
        taskFilter: "Филтър на задачите",
        itemFilter: "Филтър на елементите в календара"
    },
    organizationalCalendar: {
        title: "Организационен календар",
        modelsLoading: "Зареждане на модел/и",
        missing: "Не е създаден организационен календар.",
        gridHeaders: {
            id: "Id",
            name: "Име",
            nameEn: "Име / Английски",
            description: "Описание",
            applied: "Приложен",
            createdAt: "Време на създаване"
        },
        applyConfirmation:
            "Сигурни ли сте, че искате да приложите избраният организационен календар?"
    },
    organizationalModel: {
        title: "Организационен модел",
        titles: "Организационни модели",
        gridHeaders: {
            id: "ИД",
            name: "Име",
            nameEn: "Име / Английски",
            description: "Описание",
            deactivated: "Деактивиран",
            active: "Активен",
            loaded: "Зареден",
            eventForms: "Форма на събитие",
            eventActivities: "Дейност/Направление на събитие"
        },
        edit: "Организационен модел / Редакция",
        eventForm: "Форма на събитието",
        eventActivity: "Дейност / Направление на събитието",
        deactivateConfirm:
            "Сигурни ли сте, че искате да деактивирате организационен модел ",
        activateConfirm:
            "Сигурни ли сте, че искате да активирате организационен модел "
    },
    organizationalModelItem: {
        title: "Елемент от организационен модел",
        gridHeaders: {
            id: "Id",
            name: "Име",
            nameEn: "Име / Английски",
            expectedResult: "Очакван резултат",
            deactivated: "Деактивиран",
            active: "Активен",
            categoryDisplayName: "Категория",
            priorAlertDeadlineInDays:
                "Отместване в дни спрямо крайния срок за генериране на предупреждение до координаторите",
            deadlineToAfterBenchemarkIdDays:
                "Краен срок като отместване в дни спрямо отправната точка",
            benchmarkType: "Тип репер"
        }
    },
    organizationalCalendarItem: {
        title: "Елемент от организационен календар",
        gridHeaders: {
            id: "Id",
            name: "Име",
            nameEn: "Име / Английски",
            expectedResult: "Очакван резултат",
            deactivated: "Деактивиран",
            active: "Активен",
            categoryDisplayName: "Категория",
            priorAlertDeadlineInDays:
                "Отместване в дни спрямо крайния срок за генериране на предупреждение до координаторите",
            deadlineToAfterBenchemarkIdDays:
                "Краен срок като отместване в дни спрямо отправната точка",
            benchmarkType: "Тип репер",
            deadline: "Краен срок",
            alertDate: "Дата за предупреждение",
            printDate: "Дата на принтиране",
            applied: "Приложен",
            completedTask: "Изпълнена задача",
            completionTime: "Време за изпълнение"
        },
        applyConfirmation: "Сигурни ли сте, че искате да приложите елемент ",
        deleteConfirmation: "Сигурни ли сте, че искате да изтриете елемент ",
        taskAlreadyCompleted: "Задачата вече е изпълнена!",
        completeTask: "Изпълни"
    },
    reportData: {
        events: {
            menuTitle: "Събития",
            title: "Данни за справки / Събития",
            eventId: "ИД №",
            migrationEventId: "ИД № (миграция)",
            migrationEventStartDate: "Начална дата (миграция)",
            migrationEventStartDateHour: "Начален час (миграция)",
            eventStartDate: "Начална дата",
            eventStartDateHour: "Начален час",
            migrationEventEndDate: "Крайна дата (миграция)",
            migrationEventEndDateHour: "Час на закриване (миграция)",
            eventEndDate: "Крайна дата",
            eventEndDateHour: "Час на закриване",
            eventDirectorateId: "DirectorateId",
            migrationEventDirectorate: "Дирекция (миграция)",
            eventDirectorate: "Дирекция",
            migrationEventActivityDirection: "Дейност (Направление) (миграция)",
            eventActivityDirectionId: "ActivityDirectionId",
            eventActivityDirection: "Дейност (Направление)",
            migrationEventLegalArea: "Правна област (миграция)",
            eventLegalArea: "Правна област",
            migrationEventFundingType: "Финансиране (миграция)",
            eventFundingType: "Финансиране",
            migrationEventProjectName: "Име на проект (миграция)",
            eventProjectId: "ProjectId",
            eventProjectName: "Име на проект",
            migrationEventOrganizerName: "Организатор (Партньор) (миграция)",
            eventOrganizerName: "Организатор (Партньор)",
            migrationEventSort: "Вид събитие (миграция)",
            еventSortId: "SortId",
            eventSort: "Вид събитие",
            migrationEventName: "Име на събитие (миграция)",
            eventName: "Име на събитие",
            migrationThematicArea: "Тематична област (миграция)",
            thematicArea: "Тематична област",
            migrationContactPersons: "Лица за контакт (миграция)",
            contactPersons: "Лица за контакт",
            migrationEventVenue: "Място на провеждане (миграция)",
            eventVenue: "Място на провеждане",
            migrationEventLocation: "Населено място (миграция)",
            eventLocation: "Населено място",
            eventLocationDistrict: "Област",
            migrationLecturers: "Лектори (миграция)",
            lecturers: "Лектори",
            migrationParticipantsMaxNum: "Места (миграция)",
            participantsMaxNum: "Места",
            migrationEventAudience: "Състав на аудиторията (миграция)",
            eventAudience: "Състав на аудиторията",
            migrationHotelName: "Име на хотел (миграция)",
            hotelName: "Име на хотел",
            migrationHotelAddress: "Адрес на хотел (миграция)",
            hotelAddress: "Адрес на хотел",
            migrationLastDayForBooking:
                "Последна дата за заявка нощувки (миграция)",
            lastDayForBooking: "Последна дата за заявка нощувки",
            migrationEventStayFrom: "Нощувки от (миграция)",
            eventStayFrom: "Нощувки от",
            migrationEventStayTo: "Нощувки до (миграция)",
            eventStayTo: "Нощувки до",
            migrationEventDailyAllowanceFrom: "Дневни от (миграция)",
            eventDailyAllowanceFrom: "Дневни от",
            migrationEventDailyAllowanceTo: "Дневни до (миграция)",
            eventDailyAllowanceTo: "Дневни до",
            migrationNoteStatus: "Статус съобщение (миграция)",
            noteStatus: "Статус съобщение",
            migrationEventSubscriptionStartDate: "Начало заявяване (миграция)",
            eventSubscriptionStartDate: "Начало заявяване",
            migrationEventSubscriptionEndDate: "Край заявяване (миграция)",
            eventSubscriptionEndDate: "Край заявяване",
            migrationExcludeFromReporting: "Изключване от отчитане (миграция)",
            excludeFromReporting: "Изключване от отчитане",
            migrationEventStatus: "Статус на събитие (миграция)",
            statusId: "StatusId",
            eventStatus: "Статус на събитие",
            migrationCreatedByUserName: "Създаден от (миграция)",
            createdByUserName: "Създаден от",
            migrationCreatedAt: "Създаден на (миграция)",
            createdAt: "Създаден на",
            migrationUpdatedByUserName: "Редактиран от (миграция)",
            updatedByUserName: "Редактиран от",
            migrationUpdatedAt: "Редактиран на (миграция)",
            updatedAt: "Редактиран на",
            migrationEventNote: "Бележки (миграция)",
            eventNote: "Бележки",
            eventDescription: "Описание",
            eventExpectedResults: "Очаквани резултати",
            eventLearningGoals: "Обучителни цели",
            eventMainActivity: "Основна дейност",
            archived: "Архивирано",
            coordinators: "Координатори",
            eventForm: "Форма на събитие",
            shortDates: "Кратки дати",
            eventContactPerson: "Лица за контакт",
            eventLabel: "Етикети",
            eventCode: 'Код на събитието'
        },
        participants: {
            menuTitle: "Участници",
            pageTitle: "Данни за справки / Участници",
            participantId: "ИД",
            participantMigrationId: "ИД (миграция)",
            registerEntityId: "ИД на Събитие",
            eventMigrationId: "ИД на Събитие (миграция)",
            partRequsetFillDate: "Заявка получена на",
            gender: "Пол",
            title: "Звание / степен",
            salutation: "Обръщение",
            egn: "ЕГН",
            firstName: "Име",
            middleName: "Презиме",
            lastName: "Фамилия",
            fullName: "Имена",
            position: "@:person.position",
            migrationInstitutionName: "Институция (миграция)",
            migrationInstitutionCity: "Населено място институция (миграция)",
            institutionName: "Институция",
            institutionCity: "Населено място институция",
            phone: "Телефон",
            mobilePhone: "Мобилен",
            email: "Електронна поща",
            participationCode: "Основание за участие (Код)",
            participationName: "Основание за участие",
            reasonForAdmission: "Основание за допускане",
            deployed: "Командирован",
            cityOfCurrentAddress: "Град (село) по настоящ адрес",
            accommodationRequest: "Заявка нощувки",
            datesForNights: "Дати на нощувки",
            roomType: "Вид стая",
            travelers: "Командировъчни",
            vegetarianMenu: "Вегетарианско меню",
            note: "Бележки",
            positionStatistics: "@:person.positionStatistic",
            isMigrant: "Мигрант",
            isForeigner: "Друга държава",
            isMemberOfAMinority: "Член на малцинство",
            isOfGypsyOrigin: "Ромски произход",
            withDisabilities: "С увреждания",
            isHomeless: "Бездомно лице",
            isDisadvantaged: "Неравностойно положение",
            isFromUnemployedHousehold: "Безработно домакинство",
            withDependentChildren: "С деца на издръжка",
            fromOneMemberHousehold: "Едночленно домакинство",
            createdByUserName: "Създаден от",
            createdAt: "Създаден на",
            updatedByUserName: "Редактиран от",
            updatedAt: "Редактиран на",
            employment: "Заетост",
            education: "Образование",
            consentToBeProcessed: "Съгласие за обработка",
            participationTypeName: "Тип участие",
            statusName: "Статус на участие",
            deleted: "Изтрит",
            currentSettlement: "Настоящо населено място",
            positionFullName: "@:person.positionFullName",
            areaOfAppeal: 'Апелативен район'
        },
        participantsToMigrationTitle: "Участници и техните данни от миграция"
    },
    aspNetRole: {
        name: "Име",
        description: "Описание",
        active: "Активен",
        deactivated: "Неактивен",
        confirm: {
            delete:
                "Сигурни ли сте, че искате да изтриете ролята? Всички свързани връзки Потребител-Роля и Потребител-Роля-Право ще бъдат изтрити!"
        }
    },
    yearRangeSelector: {
        all: "Всички",
        curentYear: "Текуща година",
        previousYear: "Предишна година"
    },
    aspNetUser: {
        create: "Създаване на потребител",
        edit: "Редакция на потребител"
    },
    timer: {
        labels: {
            days: "Дни",
            hours: "Часове",
            minutes: "Минути",
            seconds: "Секунди"
        }
    },
    home: {
        myLastPaticipations: "Моите последни участия",
        event: "Събитие",
        participation: "Вид участие",
        startTime: "Начало",
        endTime: "Край",
        noData: "Няма намерени записи",
        showMore: "Покажи повече",
        myForms: "Попълнени анкети и формуляри",
        form: "Анкета/Формуляр",
        type: "Тип",
        myLastActionLogs: "Моите последни действия"
    },
    participationType: {
        title: "Тип участие",
        create: "Създаване на тип участие",
        edit: "Редакция на тип участие",
        gridHeaders: {
            id: "Id",
            name: "Име",
            nameEn: "Име / Английски",
            description: "Описание",
            isParticipation: 'Значещ "Обучаем"',
            isLecturerType: 'Значещ "Преподавател"',
            isCoordinatorType: 'Значещ "Координатор"',
            deactivated: "Неактивен",
            active: "Активен",
            participationRelationType: "Основание за участие",
            reasonForAdmission: "Основание за допускане / недопускане",
        }
    },
    dropdownList: {
        noDataFound: "Няма намерени данни.",
        createQuestion: "Искате ли да добавите нов елемент?"
    },
    claims: {
        title: "Роли",
        evenatClaimsAdministration: "Администриране на права на събитие",
        existingClaims: "Съществуващи права",
        loadedClaims: "Заредени права",
        eventClaimsInfo:
            "Списък с права за дадено събитие. Даването на дадено право на определен тип участие определя правата за работа със съответния раздел. Правата се онаследяват първо от потребителската група на потребителя, след което от ролите му на участия в събитието."
    },
    benchmarkType: {
        title: "Тип репер / Администрация",
        gridHeaders: {
            id: "Id",
            name: "Име",
            nameEn: "Име / Английски",
            code: "Код",
            deactivated: "Неактивен"
        }
    },
    certificates: {
        number: "№ сертификат",
        personName: "Име, длъжност, институция",
        eventName: "Събитие",
        eventCode: "Код на събитието",
        evaluation: "Оценка",
        validFrom: "Валиден от",
        validTo: "Валиден до",
        createdOn: "Създадено на",
        createdBy: "Създадено от",
        title: "Сертификати",
        certificate: "Сертификат",
        download: "Свали сертификат",
        delete: "Изтрий",
        deletion: "Изтриване",
        eventId: "Събитие ИД №",
        deletionMessage:
            "Сигурни ли сте, че искате да изтриете този сертификат?",
        template: {
            noData: "Шаблони за сертификат",
            title: "Използван шаблон на сертификат",
            label: "Име на шаблон",
            help: "Определя кой шаблон ще бъде използван при генериране на сертификатите за участие в даденото събитие. Зареждат се публикуваните в категория 'Сертификати' или тази, определена в конфигурационните настройки на приложението."
        },
        help:
            'Опцията за издаване на нов сертификат е активна при наличие на следните условия: Типът участие да е "Участник" и статусът на участие да е "Завършил със сертификат".',
        moodleCertificateHelp: 'Участници в Mудъл, които имат завършена дейност "Удостоверение за завършено обучение" или както e именувана допълнителната добавка за издаване на сертификати(modname="customcert"). Ако допълнителната дейност е заключена или не е видима няма да се заредат данни, поради невъзможност да се прочетат от Мудъл.',
    },
    upcomingEvents: {
        title: "Предстоящи събития",
        description: "Възможни действия по предстоящи събития",
        gridHeaders: {
            id: "ИД №",
            name: "Събитие",
            startTime: "Начало на събитието",
            endTime: "Край на събитието",
            statuses: "Статуси",
            contactPerson: "@:contactPerson",
            audience: "@:registers.events.gridHeaders.eventAudience"
        },
        noData: "Няма намерени записи",
        completeSubsForm: "Попълни заявление за участие",
        editSubsForm: "Редактирай заявление за участие",
        participationRequestConfirmation:
            "Потвърждаване на заявката за участие",
        participationRequestRejection: "Отхвърляне на заявката за участие",
        notificationSubsciption:
            "Абониране за известие при активиране на заявяване за участие",
        notificationUnsubsciption:
            "Премахване на абонирането за известие при активиране на заявяване за участие",
        confirmations: {
            notificationSubsciption:
                "Сигурни ли сте, че искате да се абонирате за известие при активиране на заявяване за участие за избраното събитие?",
            notificationUnsubsciption:
                "Сигурни ли сте, че искате да премахнете абонирането за известие при активиране на заявяване за участие за избраното събитие?"
        },
        email: "Електронна поща",
        note: "Бележка",
        help: {
            upcomingEvent: "За предстоящо събитие се счита това, което е публично, няма въведена дата за начало на събитието или тя не е настъпила. Предстоящите събития са видими за потребители с необходимото право (UpcomingEvent.Read).",
            subscriptionForEvent: "Бутонът за заявяване на участие е видим при наличието на необходимото право(FormSurveyEntity.Create) и има създаден формуляр от тип 'Заявяване на участие', който е активен за попълване.",
            subscriptionForEventEdit: "Бутонът за редактиране на заявяване на участие е видим при наличието на горните условия и потребител, попълнил формуляр за 'Заявяване на участие'.",
            notificationSubsciption: "Бутонът за 'Абониране за известие при активиране на заявяване за участие' е видими за 'Предстоящи събития', за който няма създаден формуляр от тип 'Заявяване на участие'."
        },
        wrongEmailInfo: "Електронната поща се взима от профилните данни. Ако е грешна може да се промени в Профил/Лични данни."
    },
    participationConfirmation: {
        modalTitle: "Потвърждение на участие",
        accommodationRequired: "Необходимо настаняване",
        transportationRequired: "Необходим транспорт",
        vegetarianMenuRequired: "Вегетарианско меню",
        note: "Бележка",
        fromDate: "От",
        toDate: "До",
        fromDateDescription: 'Посочете първия ден на нощувката',
        toDateDescription: 'Посочете деня / датата на напускане на хотела',
        accommodationPlace: "Място на настаняване",
        accommodationType: "Тип настаняване",
        accommodationRequiredHelp: "",
        transportationRequiredHelp: "",
        vegetarianMenuRequiredHelp: "",
        notification: "Събитие: {eventName} / От: {personName}"
    },
    participationRejection: {
        modalTitle: "Отхвърляне на участие",
        notification: "Събитие: {eventName} / От: {personName}"
    },
    notificationsPopup: {
        eventAdded: {
            title: "Добавено събитие"
        },
        eventUpdated: {
            title: "Редактирано събитие"
        },
        eventDeleted: {
            title: "Изтрито събитие"
        },
        participantAdded: {
            title: "Добавен участник в събитие"
        },
        participantUpdated: {
            title: "Променен участник в събитие"
        },
        participantDeleted: {
            title: "Изтрит участник в събитие"
        },
        taskAdded: {
            title: "Добавена задача"
        },
        taskUpdated: {
            title: "Променена задача"
        },
        taskDeleted: {
            title: "Изтрита/архивирана задача"
        },
        registerImport: {
            errorTitle: "Грешка при импортиране!"
        }
    },
    participationRelationType: {
        title: "Основание за участие",
        create: "Създаване на основание за участие",
        edit: "Редакция на основание за участие",
        gridHeaders: {
            id: "Id",
            name: "Име",
            nameEn: "Име / Английски",
            description: "Описание",
            sort: "Ред на сортиране",
            deactivated: "Неактивен",
            active: "Активен",
            participationTypes: "Тип участие",
            participationTypesEn: "Тип участие / Английски"
        }
    },
    reasonForAdmission: {
        title: "Основание за допускане / недопускане",
        gridHeaders: {
            id: "Id",
            name: "Име",
            nameEn: "Име (En)",
            note: "Бележка",
            deactivated: "Деактивиран",
            active: "Активен",
            sort: "Число за сортиране",
            participationType: "Тип участие"
        }
    },
    registerStatus: {
        title: "Статус на събитие",
        gridHeaders: {
            id: "Id",
            name: "Име",
            nameEn: "Име (En)",
            deactivated: "Деактивиран",
            active: "Активен",
            isCompleted: "Значещ завършил"
        }
    },
    localization: {
        bgTitle: "Текстове на етикети на български",
        enTitle: "Текстове на етикети на английски",
        bgJsonSchemaError:
            'Невалидна json структура на "@:localization.bgTitle"',
        enJsonSchemaError:
            'Невалидна json структура на "@:localization.enTitle"',
        help:
            "Обект с множество Ключ:Стойност елементи. Променят се стойностите. Ключовете не трябва да бъдат променяни! Необходимо е да се поддържа валидна структура на json обект!"
    },
    applicationSettings: {
        title: "@:sideMenu.applicationSettings",
        userSettings: {
            title: "Потребителски настройки",
            registrationDefaultUserRole: "Роля по подразбиране",
            help: {
                registrationDefaultUserRole:
                    "Определя ролята по подразбиране, която получава всеки саморегистрирал се потребител"
            }
        },
        eventSettings: {
            title: "Настройки на събитие",
            createNewFormOnAddToEvent:
                "Създаване на нов формуляр при добавянето на шаблон към събитие",
            checkEventTimeRangeOnFormAddToEvent:
                "Проверка за припокриване на периода на активност на събитието и периода на активност на формуляра",
            checkEventSubscriptionTimeRangeOnFormAddToEvent:
                'Проверка за припокриване на периода на активност на "Бутон за кандидатстване/записване" (раздел "Общи данни") и периода на активност на формуляра',
            skipRankingQuotaEvaluation:
                "Изключване на оценката по квоти при генериране на временно класиране",
            rankWithNoneQuotes: "Класиране на невлезнали в нито една квота заявки за участие",
            rerankDropoutFromQuota: "Класиране на отпадналите от квота за останалите свободни места",
            moodleEventNameComposingPattern: "Модел за образуване на пълното наименование на Moodle курс",
            filterParticipationRelationTypeByParticipationType: "Филтриране на '@:participationRelationType.title'",
            filterReasonForAdmissionByParticipationType: "Филтриране на '@:reasonForAdmission.title'",
            createInstitutionOnParticipantsImport: "Създаването на записи в регистър '@:institution.title' при импортиране на участници от excel.",
            accommodationRequestDaterangeMinLimitToFieldRelation: "Код на динамично поле определящо минималната стойност на контролата за избор на дати за настаняване",
            accommodationRequestDaterangeMaxLimitToFieldRelation: "Код на динамично поле определящо максималната стойност на контролата за избор на дати за настаняване",
            accommodationRequestDaterangeLimitToEventsSkip: "Събитие изключено от контролите за избор на дати за настаняване",
            help: {
                createNewFormOnAddToEvent: "",
                checkEventTimeRangeOnFormAddToEvent: "",
                checkEventSubscriptionTimeRangeOnFormAddToEvent: "",
                skipRankingQuotaEvaluation: "При създаване на временно класиране няма да се направи оценка на включените в критериите квоти. Класирането ще се извърши по общ критерии(точки и време на подаване на заявката за участие).",
                rankWithNoneQuotes: "При наличието на квоти в критериите за класиране ще позволи на неприсъстващите в нито една квота да бъдат класирани за истаналите незаети места. Под неприсъстващи в квотоа се има предвид тези, които не отговарят на изискванията за дадена квота, а не тези, които са извън позволената бройка за квота.",
                rerankDropoutFromQuota: "Отпадналите над максимално допутимите за квота участват в класиране за останлите незаети места по общ критерии (точки и време на подаване на заявката за участие).",
                moodleEventNameComposingPattern: "",
                filterParticipationRelationTypeByParticipationType: "Филтрира падащото меню '@:participationRelationType.title' в заивисимост от избрания '@:participationType.title'",
                filterReasonForAdmissionByParticipationType: "Филтрира падащото меню '@:reasonForAdmission.title' в заивисимост от избрания '@:participationType.title'",
                createInstitutionOnParticipantsImport: "Разрешава създаването на записи в регистър '@:institution.title' при импортиране на участници от excel."
            }
        },
        isupoSettings: {
            title: "Настройки на Isupo",
            schema: "Схема",
            hostName: "Име на хост",
            migrateParticipantsInSingleStatement:
                "Миграция на участници в една SQL заявка",
            migrateParticipantsBatchSize: "Брой команди в една SQL заявка",
            showDraftReports:
                "Показване на справки, които не са публикувани(са чернови)",
            loadLocalizationFromDb:
                "Зареждане на превода на текстовете от базата",
            includeMergedProfiles: "Включване в търсенето на обединени профили",
            help: {
                schema: "",
                hostName: "",
                migrateParticipantsInSingleStatement: "",
                migrateParticipantsBatchSize: "",
                showDraftReports: "",
                loadLocalizationFromDb: "",
                includeMergedProfiles:
                    "Определя дали в компонента за търсене/зареждане на личност да се зареждат обединени такива."
            }
        },
        signingSettings: {
            title: "Настройки на подписването с КЕП",
            certificateDefaultAssigneeUsername: "Подписващ сертификати по подразбиране",
            defaultPdfSignatureVisualizatonType: "Default PDF signature visualization type",
            defaultPdfReason: "PDF default signature reason",
            defaultPdfContact: "PDF default signature contact",
            defaultPdfLocation: "PDF default signature location",
            defaultPdfRectagle: "PDF default signature rectangle coords",
            pdfSignatureVisualizationIsVisible: "Видима сигнатура в документа",
            defaultDocxName: "Default DOCX name",
            defaultDocxTitle: "Default DOCX title",
            defaultDocxEmail: "Default DOCX email",
            pdfReason: "PDF signature reason",
            pdfContact: "PDF signature contact",
            pdfLocation: "PDF signature location",
            pdfRectangle: "PDF signature rectangle coords",
            reportingTemplateName: "Име на шаблон",
            addReportingTemplate: "Добавяне на шаблон",
            reportingTemplatePdfSignatureVisualizatonType: "PDF signature visualization type",
            username: "Потребителско име",
            bookmarkId: "Bookmark ID",
            addUserSettings: "Добавяне на потребителски настройки",
            turnOnCertificateSigning: "Включване на подписването на сертификати"
        },
        formSettings: {
            title: "Настройки на формуляр",
            formTypesWithAnonymousFillingAllowed: "Формуляри с позволено анонимно попълване"
        }
    },
    report: {
        title: "Генериране на документ",
        category: "Категория",
        report: "Справка",
        params: "Параметри",
        generate: "Генерирай",
        newGeneratedDoc: "Нов документ от шаблон",
        format: "Тип на документа",
        chooseFormat: "Изберете тип на документа",
        template: "Шаблон",
        docTitle: "Име на документа",
        docTitleInfo: "С това име документът ще бъде запаметен в базата данни.",
        grid: {
            title: "Име",
            type: "Вид",
            generatedBy: "Генериран от",
            generatedOn: "Генериран на",
            actions: "Действия",
            isPublic: "Публичен"
        }
    },
    formsFilterSource: {
        all: "Всички",
        templates: "Шаблони",
        notTamplates: "Не са шаблони"
    },
    documentsUpload: "Прикачване на документи",
    uploadExistingDocs: "Качи съществуващи документи",
    rankingCriteria: {
        title: "@:sideMenu.rankingCriteria",
        create: "@:buttons.create.btnText @:rankingCriteria.title",
        edit: "@:buttons.edit.btnText на @:rankingCriteria.title",
        details: "@:buttons.details.btnText на @:rankingCriteria.title",
        gridHeaders: {
            id: "Ид №",
            name: "Име",
            nameEn: "Име /Английски",
            other1: "Друго 1",
            other2: "Друго 2",
            deactivated: "Деактивиран",
            creatorUsername: "Създено от",
            createdAtUtc: "Създено на",
            updaterUsername: "Обновено от",
            updatedAtUtc: "Обновено на",
            eventForm: 'Форма на събитие'
        },
        editor: {
            name: "@:rankingCriteria.gridHeaders.name",
            nameEn: "@:rankingCriteria.gridHeaders.nameEn",
            other1: "@:rankingCriteria.gridHeaders.other1",
            other2: "@:rankingCriteria.gridHeaders.other2",
            deactivated: "@:rankingCriteria.gridHeaders.deactivated",
            rules: "Правила",
            exceptions: "Изключения",
            firstInTimeFirstInLaw: "Първи по време - първи по право",
            manuallyAdded: "Ръчно включен",
            constraints: "Ограничения",
            evaluations: "Оценки",
            quotas: "Квоти",
            type: "Тип",
            kind: "Вид",
            score: "Оценка",
            count: "Брой",
            appellateRegion: "@:institution.appellateRegion",
            institution: "@:institution.information",
            position: "@:person.position",
            professionalOrientation: "@:person.positionStatistic",
            fieldValue: "Стойност на поле",
            operator: "Оператор",
            min: "Минимум",
            max: "Максимум",
            notParticipatesInOverlappingEvent:
                "Не участва в застъпващо се по време друго събитие",
            hasConsentOfTheManager: "Има съгласие на ръководител",
            isCurrentYear: "Текуща година",
            from: "От",
            to: "До",
            audience: "Целева аудитория",
            copyToRegister: "Направи копие в регистъра",
            searchFieldName: "Име на поле за търсене",
            eventForm: 'Форма на събитие',
            help: {
                searchFieldName: "Определя кое поле от формулярa за заявяване на участие ще се използва при прилагане на квотата",
                searchValue: "Множественият избор се разделя чрез разделител '/'. Стойността ще се преведе до изпълнение на ИЛИ.",
            }
        },
        confirmations: {
            create:
                "Сигурни ли сте, че искате да създадете критерии за класиране ",
            edit:
                "Сигурни ли сте, че искате да редактирате критерии за класиране ",
            delete:
                "Сигурни ли сте, че искате да изтриете критерии за класиране ",
            addToEvent:
                "Сигурни ли сте, че искате да добавите избраните критерии за класиране?"
        },
        help: {
            copyToRegister:
                "Ще копира критерият за класиране в регисъра 'Критерии за класиране'"
        }
    },
    participationRequest: {
        title: "Заявки за участие",
        gridHeaders: {
            id: "Ид №",
            name: "Име",
            username: "Потребител",
            email: "Ел.поща",
            position: "@:person.position",
            positionStatistic: "@:person.positionStatistic",
            positionStr: "@:person.positionFullName",
            institutionName: "Институция",
            institutionCity: "Населено място",
            createdAtUtc: "Създено на",
            updatedAtUtc: "Обновено на",
            formName: "Име на формуляр",
            formType: "Тип на формуляр",
            status: "Статус",
            eventName: "Име на събитие"
        }
    },
    sentEmails: {
        title: "@:sideMenu.sentEmails",
        gridHeaders: {
            Subject: "Заглавие",
            Body: "Съдържание",
            To: "До",
            Cc: "С копие до",
            Bcc: "Скрито копие до",
            CreatedBy: "Създадено от",
            Errors: "Детайли на грешката",
            Note: "Бележка",
            CreatedAtUtc: "Създено на",
            SentTimeUtc: "Време на изпращане",
            ErrorTimeUtc: "Време на грешка",
            HasError: "Грешка",
            OtherNotification: "Друг тип уведомяване",
            OtherNotificationAt: "Друг тип уведомяване на",
            UninformedParticipants: "Неуведомени участници",
            NotifiedAt: 'Уведомен на',
            Notified: 'Уведомен'
        }
    },
    eventDocuments: {
        title: "Генерирани шаблони от събития",
        eventDocsGrid: {
            documentId: "ИД",
            fileName: "Име на документ",
            docType: "Тип",
            createdBy: "Генериран от",
            createdOn: "Генериран на",
            registerEntityId: "ИД на събитие",
            eventName: "Събитие",
            eventStartDate: "Начало събитие",
            eventEndDate: "Край събитие",
            eventLocation: "Населено място",
            eventMainActivity: "Основна дейност",
            eventActivityDirection: "Направление",
            eventDirectorate: "Дирекция",
            eventProjectName: "Проект",
            actions: "Действия",
            openEvent: "Към събитието",
            eventCode: "Код на събитието",
            eventSubscriptionStartDate: "Подаване на заявки от",
            eventSubscriptionEndDate: "Подаване на заявки до",
            eventStatus: "Статус",
            eventForm: "Форма на събитието",
            eventSort: "Вид на събитието",
            eventVenue: "Място на провеждане / институция",
            eventOrganizerName: "Организатор/Партньор",
            eventLegalArea: "Правна област",
            eventFundingType: "Финансиране",
            eventNote: "Бележки",
            thematicArea: "Тематична област",
            theme: "Тема",
            eventMoodleCategory: "Moodle Категория"
        }
    },
	eventDescription: {
        connectedEventData: 'Данни за свързано събитие',
		eventName: 'Име на събитие',
		eventPlace: 'Място на провеждане',
		startDate: 'Начална дата',
		endDate: 'Крайна дата',
		project: 'Проект',
		organizer: 'Организатор',
		lecturers: 'Преподаватели'
    },
    dynamicLayout: {
        editPanelSize: "Редактиране на размера на панела",
        size: "Размер",
        enterValidValue: "Моля въведете стойност от 1 до 12.",
        panelsVisible: "Панели, видими на страницата",
        eligiblePanels: "Налични панели",
        homePageLayout: "План на началната страница",
        removeFromPage: "Премахни от видимите панели на страницата"
    },
    responseErrors: {
        valueCannotBeNull: "Стойността не може да бъде null",
        parameterName: "Име на параметър",
        objectReference: "Object reference not set to an instance of an object",
        noEventDateToSync: "No event data to sync",
        statusOfUndefined: "Cannot read property 'status' of undefined_ Test",
        networkError: "Възникна проблем при комуникацията със сървъра",
    },
    fieldCodes: {
        title: "Кодове на полета",
        gridHeaders: {
            fieldName: "Име",
            code: "Код",
            description: "Описание",
            isForDynamicForm: "За формуляри"
        }
    },
    dinamicField: {
        gridHeaders: {
            id: "ИД №",
            name: "Име на поле",
            label: "Етикет на поле",
            fieldType: 'Тип на поле',
            description: 'Описание',
            usedIn: 'Използва се в',
            formId: 'ИД № на формуляр'
        }
    },
    auxiliary: {
        title: 'Спомагателни регистри',
        gridHeaders: {
            id: "ИД №",
            name: "Име",
            active: "Активен"
        },
        notAuthorized: "Нямате необходимите права за работа със @:auxiliary.title"
    },
    help: {
        menuTitle: 'Помощ',
        title: 'Помощ',
        name: 'Име',
        nameEn: 'Име (En)',
        parent: 'Родител',
        deactivated: 'Неактивен',
        includeDeactivated: "Включване на неактивните",
        sort: "Число за сортиране",
    },
    organizationalCalendarSettings: {
        title: 'Сървърни настройки за зареждане на орг. модели',
        override: 'Презаписване на настройките',
        loadOnlyValidModels: 'Зареждане на "Валидни" орг. модели',
        calendarModelsANDFilter: 'Прилагане на AND филтър',
        help: {
            override: 'Подава дефинирани от потребителя настройки за зареждане на орг. модели.',
            loadOnlyValidModels: 'Показва организационните модели избрани като шаблонни за "формата" или "дейността/направлението" на даденото събитие.',
            calendarModelsANDFilter: 'Предлагане на организационни модели според Форма на събитие И/ИЛИ Направление на събитие. Ако не е избрано ще приложи И филтър.'
        }
    },
    policy: {
        title: "Политика|Политики"
    },
    signing: {
        pageTitle: "Процедура по подписване|Процедури по подписване",
        new: "Нова",
        edit: "Редакция",
        assignedToMe: "Възложени на мен",
        createdByMe: "@:coordinations.createdByMe",
        sign: "Подпиши",
        innerType: "Вътрешно",
        innerTypeMessage:
            "Подписването не изисква изходящ номер от деловодната система.",
        ongoing: "в процес ...",
        outgoingType: "Външно",
        outgoingTypeMessage:
            "Подписването изисква изходящ номер от деловодната система. Деловодителя трябва да приключи процедурата.",
        clerk: "Деловодител",
        attachments: "Прикачени документи",
        headers: {
            id: "ИД №",
            title: "@:coordinations.title",
            status: "@:coordinations.status",
            signatories: "Подписващ",
            creator: "Създател",
            deadline: "Краен срок",
            statDate: "Дата на стартиране",
            type: "Тип",
            archived: "@:coordinations.archived"
        },
        relatedTask: "Свързана задача",
        relatedCoordination: "Свързано съгласуване",
        filesGirdHeaders: {
            fileName: "Име",
            fileDescription: "Описание",
            isSigned: "Подписан",
            timestampUtc: "Време на подписаване",
            signedBy: "Подписан от",
        },
        noSignatoriesMsg: "Липсва добавено лице за подписване",
        startTitle: "Стартиране на процедурата по подписване",
        startMessage: "Сигурни ли сте, че искате да стартирате процедурата по подписване?",
        deletionConfirmMessage: "Сигурни ли сте, че искате да изтриете процедурата по подписване?",
        history: "@:tasks.history",
        details: "@:tasks.details",
        result: "@:coordinations.result",
        isSigned: "@:signing.filesGirdHeaders.isSigned",
        activities: {
            New: "създаде процедурата по подписване",
            Edited: "редактира процедурата по подписване",
            Canceled: "прекрати процедурата по подписване",
            Archived: "архивира процедурата по подписване",
            Unarchived: "разархивира процедурата по подписване",
            Started: "стартира процедурата по подписване",
            Deleted: "изтри процедурата по подписване",
            Completed: "завърши процедурата по подписване",
        },
        signing: "@:sideMenu.signing",
        complete: "Завърши",
        emptyModelError: "Празен или невалиден модел",
        missingSelectedAttachmentsToSign: "Не са избрани документи за подписване",
        completeTitle: "Завършване на процедурата по подписване",
        completeMessage: "Сигурни ли сте, че искате да завършите процедурата по подписване?",
        missingSelectedOrganizationalDocuments: "Не са избрани организационни документи",
        organizationalDocumentsSigningCreateConfirmation: "Сигурни ли сте, че искате да създадете процедурата по подписване от избраните организационни документи?",
        archiveMessage: "Сигурни ли Сте, че искате да архивирате тази процедурата по подписване? След като се архивира, тя няма да се вижда в списъци и търсения.",
        unarchiveMessage: `Сигурни ли Сте, че искате да разархивирате тази процедурата по подписване? След като се разархивирана, тя ще бъде видима в списъци и търсения.`,
        allowedFilesTypesForSigning: "Могат да се подписват само .pdf и .docx файлове",
        createFromOrganizationalDocuments: "Създай процедура по подписване от избраните документи",
        unfinished: "Незавършени процедури по подписване",
        overdue: "Просрочена",
        signed: "Подписан|Подписани",
        unsigned: "Неподписан|Неподписани",
        started: "Стартирана|Стартирани",
        completed: "Завършена|Завършени",
        forSigning: "За подпис",

    },
    accommodationRequest: {
        gridHeaders: {
            id: "Ид №",
            name: "Име",
            email: "Ел.поща",
            single: "@:accommodation.single",
            double: "@:accommodation.double",
            triple: "@:accommodation.triple",
            apartment: "@:accommodation.apartment",
            accommodationPlaceName: "@:participationConfirmation.accommodationPlace",
            accommodationPlaceNameCity: "Град",
            note: "@:participationConfirmation.note",
            fromDate: "@:participationConfirmation.fromDate",
            toDate: "@:participationConfirmation.toDate",
            accommodationRequired: "@:participationConfirmation.accommodationRequired",
            vegetarianMenuRequired: "@:participationConfirmation.vegetarianMenuRequired",
            transportationRequired: "@:participationConfirmation.transportationRequired",
            confirmedByAdmin: "Потвърдено от администратор",
            lastUpdateDate: "Обновено на",
            lastUpdater: "Обновено от"
        }
    },
    deletedRecords: {
        lecturers: "Маркирани като изтрити преподаватели",
        institutions: "Маркирани като изтрити институции и организации",
        places: "Маркирани като изтрити места за провеждане",
        accommodationPlaces: "Маркирани като изтрити места за настаняване",
        publicOrders: "Маркирани като изтрити обществени поръчки",
        projects: "Маркирани като изтрити проекти",
        activities: "Маркирани като изтрити дейности направления",
        thematicAreas: "Маркирани като изтрити тематични области",
        administrativePositions: "Маркирани като изтрити длъжности в НИП",
        deletedEvents: "Събития маркирани като изтрити",
        deletedDocuments: "Учебни материали, Отчетни документи, Организационни документи, маркирани като изтрити"
    },
    confirmationRejection: {
        title: "Отхвърлени заявки за участие",
        id: "ИД №",
        note: "@:participationConfirmation.note",
        rejectedByAdmin: "Отхвърлено от администратор",
        user: "@:userName",
        time: "Време",
        name: "Име",
        username: "Потребителско име",
        email: "Ел.поща",
        rankingVersion: "Версия на вр.класиране",
        isRankingActive: "Активно вр.класиране",
        confirmationDelete: "Сигурни ли сте, че искате да изтриете отхвърлянето на потвърждението за участие на {name}?",
    },
    dataReference: {
        replacePrompt: "Моля, въведете ИД №, с който ще заместваме.",
        replacementHistory: {
            id: "ИД №",
            schemaName: "ДБ схема",
            tableName: "ДБ таблица",
            entityId: "ИД № на ред",
            timestampUtc: "Време на създаване"
        }
    },
    clientCertificate: {
        title: "КЕП"
    },
    localServer: {
        title: "Локален сървър",
        version: "Версия",
        type: "Вариант",
        currentInstalation: "Текуща инсталация",
        currentInstalationDescription: "Проверява се работоспособността на инсталацията на текущия компютър",
        ability: "Възможности",
        settings: "Настройки",
        check: "Провери",
        instalationCheck: "Проверка на инсталация",
        instalationCheckDescription: "За проверка се изпълнява тестово подписване",
        data: "Данни",
        message: "Съобщение",
        addData: "Допълнителна информация",
        parseSource: "Данни",
        parseResult: "Резултат"
    },
    signingProcedureFiling: {
        pageTitle: "Завеждане на документи от процедури по подписване",
        file: "Завеждане",
        filed: "Заведен|Заведени",
        unfiled: "Незавед|Незаведени",
        headers: {
            filingDate: "Дата на завеждане",
            filedBy: "Заведен от",
            number: "Вх. №"
        },
        filePrompt: "Завеждане на документ '{name}'. Моля, въведете вх.№ или друга информация."
    },
    versionChangeMsg: "Има промяна във версията на приложението! Mоля, опреснете съдържанието на страницата.",
    deletedDocument: {
        headers: {
            docType: 'Тип',
            fileName: 'Име на файл',
            description: 'Описание',
            eventId: 'ИД № на събитие',
            eventName: 'Име на събитие',
            eventCode: 'Кратко име на събитие',
            deletedOn: 'Дата на изтриване',
            deletedBy: 'Изтрито от'
        }
    },
    fileSelection: {
        computer: 'Компютър',
        reportingDocs: 'Отчетни документи',
        organizationalDocs: 'Организационни документи'
    }
};
